import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { FiPower } from "react-icons/fi";
import "./Dashboard.css";
import RemarkModal from "./RemarkModal";
// import Chatbot from "./Chatbot";
// import "./Chatbot.css";
import "./RemarkModal.css"; // ✅ Import CSS for modal here
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css"; // optional default styling
// import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import Swal from "sweetalert2";
import Draggable from 'react-draggable';
import API_BASE_URL from "../apiConfig";

const Dashboard = () => {
  const [openingCash, setOpeningCash] = useState("");
  const [cashSalesA, setCashSalesA] = useState("");
  const [cashDeposited, setCashDeposited] = useState("");
  const [cashAdjustment, setCashAdjustment] = useState("");
  const [closingCash, setClosingCash] = useState("");

  const [cashSalesB, setCashSalesB] = useState("");
  const [eSales, setESales] = useState("");
  const [eSalesAdjustment, setESalesAdjustment] = useState("");
  const [gvRedemption, setGvRedemption] = useState("");
  const [dayTarget, setDayTarget] = useState("");
  const [totalSales, setTotalSales] = useState("");
  const [ogtotalSales, setOriginalTotalSales] = useState("");
  const [mtdTarget, setMtdTarget] = useState("");
  const [mtdSales, setMtdSales] = useState("");
  const [backendMtdSales, setBackendMtdSales] = useState(""); // from API
  const [backlog, setBacklog] = useState("");
  const [monthTarget, setMonthTarget] = useState("");
  const [achievedPercent, setAchievedPercent] = useState("");
  const [totalBills, setTotalBills] = useState("");
  const [manualBillNo, setManualBillNo] = useState("");
  const [walkins, setWalkins] = useState("");
  const [headcount, setHeadcount] = useState("");
  const [isMonthTarget, setIsMonthTarget] = useState(false);

  const [mtdAchievedPercent, setMtdAchievedPercent] = useState("");

  const [openingStock, setOpeningStock] = useState("");
  const [stockInward, setStockInward] = useState("");
  const [stockOutward, setStockOutward] = useState("");
  const [saleQty, setSaleQty] = useState("");
  const [stockAdjustment, setStockAdjustment] = useState("");
  const [closingStock, setClosingStock] = useState("");

  const sectionASubmitRef = useRef(null);
  const sectionBSubmitRef = useRef(null);
  const stockAdjustmentRef = useRef(null); // ✅ add this

  const [rawSectionData, setRawSectionData] = useState({ A: [], B: [], C: [] });

  const [selectedRow, setSelectedRow] = useState(null); //aug 14

  const [docType, setDocType] = useState("sales"); //aug19
  const [file, setFile] = useState(null);
  const [stores, setStores] = useState([]); // for list of stores from API
  const [selectedStore, setSelectedStore] = useState(""); // chosen store

  const [hover, setHover] = useState(false);
  const [hoverExcel, setHoverExcel] = useState(false);

  const [isEditingSectionA, setIsEditingSectionA] = useState(false);
  const [isEditingSectionB, setIsEditingSectionB] = useState(false);
  const [isEditingSectionC, setIsEditingSectionC] = useState(false);

  const [isRemarkModalOpenA, setIsRemarkModalOpenA] = useState(false);
  const [isRemarkModalOpenB, setIsRemarkModalOpenB] = useState(false);
  const [isRemarkModalOpenC, setIsRemarkModalOpenC] = useState(false);

  const [isSubmittedA, setIsSubmittedA] = useState(false);
  const [isSubmittedB, setIsSubmittedB] = useState(false);
  const [isSubmittedC, setIsSubmittedC] = useState(false);

  // Optional: disable future dates if previous not submitted
  const [canEditNextDate, setCanEditNextDate] = useState(true);

  const [stockInwardType, setStockInwardType] = useState("inwHO", "OwHO"); // default HO
  const [showStockModal, setShowStockModal] = useState(false);
  const [invoiceNo, setInvoiceNo] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [discrepancyOption, setDiscrepancyOption] = useState("none"); // "none" | "found"
  const [selectedDiscrepancies, setSelectedDiscrepancies] = useState([]);
  const [remark, setRemark] = useState("");

  // For Cash Adjustment modal
  const [showCashModal, setShowCashModal] = useState(false);
  const [cashReason, setCashReason] = useState("");
  const [cashRemark, setCashRemark] = useState("");
  const [cashDiscrepancyOption, setCashDiscrepancyOption] = useState("");
  const [selectedCashDiscrepancies, setSelectedCashDiscrepancies] = useState(
    []
  );
  const [selectedBank, setSelectedBank] = useState("");
  const [bankData, setBankData] = useState([]);
  const [isUploading, setIsUploading] = useState(false);

  // For Cash Adjustment modal
  // const [showCashModal, setShowCashModal] = useState(false);
  const [cashAdjustmentReason, setCashAdjustmentReason] = useState("");
  const [cashAdjustmentRemark, setCashAdjustmentRemark] = useState("");

  const cashAdjustmentRef = useRef(null); // optional, for focusing field
  const nextFieldRef = useRef(null); // the next field after cash adjustment

  const [remarkModalTitleA, setRemarkModalTitleA] = useState(""); // Section A
  const [remarkModalTitleB, setRemarkModalTitleB] = useState(""); // Section B
  const [remarkModalTitleC, setRemarkModalTitleC] = useState(""); // Section C

  const saveCashAdjustment = () => {
    // Example: save to backend
    const payload = {
      cashAdjustment: parseFloat(cashAdjustment),
      reason: cashAdjustmentReason,
      remark: cashAdjustmentRemark,
      userID,
      selectedDate,
      section: "A",
    };

    console.log("Saving Cash Adjustment:", payload);

    // TODO: call your API here using fetch/axios
  };

  const [stockData, setStockData] = useState({
    StockTransferInwNo: "", // 🔹 renamed
    StockTransferOutwNo: "", // 🔹 new
    StockTransferDate: "",
    StockDiscrepancyStatus: "None",
    StockSelectedDiscrepancy: "",
    DiscrepancyRemark: "",
  });

  const eSalesAdjustmentRef = useRef(null); //sep-23

  useEffect(() => {
    if (showStockModal) {
      // 🔹 Use correct field based on modal type
      if (stockModalType === "inward") {
        setInvoiceNo(stockData.StockTransferInwNo || "");
      } else if (stockModalType === "outward") {
        setInvoiceNo(stockData.StockTransferOutwNo || "");
      }

      setInvoiceDate(stockData.StockTransferDate || "");
      setDiscrepancyOption(
        stockData.StockDiscrepancyStatus === "Found" ? "found" : "none"
      );
      setSelectedDiscrepancies(
        stockData.StockSelectedDiscrepancy
          ? stockData.StockSelectedDiscrepancy.split(",")
          : []
      );
      setRemark(stockData.DiscrepancyRemark || "");
    }
  }, [showStockModal, stockData]);

  const saveStockTransfer = async () => {
    let payload = {
      action: "save",
      userID: userID,
      selectedDate: selectedDate,
      // StockTransferNo: invoiceNo,
      StockTransferDate: invoiceDate,
      StockDiscrepancyStatus: discrepancyOption === "found" ? "Found" : "None",
      StockSelectedDiscrepancy: selectedDiscrepancies.join(","), // convert array to CSV
      DiscrepancyRemark: remark,
      OpeningStock: openingStock,
      ClosingStock: closingStock
    };

    // 🔹 Assign correct StockTransfer number based on modal type
    if (stockModalType === "inward") {
      payload.StockTransferInwNo = invoiceNo;
    } else if (stockModalType === "outward") {
      payload.StockTransferOutwNo = invoiceNo;
    }

    // ✅ Assign only the matching field
    if (stockModalType === "inward" && stockInwardType === "inwHO") {
      payload.stockInwHO = stockInward;
    } else if (
      stockModalType === "inward" &&
      stockInwardType === "inwOtherStore"
    ) {
      payload.stockInwStore = stockInward;
    } else if (stockModalType === "outward" && stockInwardType === "OwHO") {
      payload.stockOutwHO = stockOutward;
    } else if (
      stockModalType === "outward" &&
      stockInwardType === "owOtherStore"
    ) {
      payload.stockOutwStore = stockOutward;
    }

    console.log("Final Payload:", payload);

    try {
      const response = await fetch(
        `${API_BASE_URL}/api/eod_stocktransfer.php`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();
      if (result.success) {
        alert("Stock Transfer saved successfully!");
        setShowStockModal(false);
        // Optionally refetch the data
      } else {
        alert("Error: " + result.message);
      }
    } catch (error) {
      console.error("Error saving stock transfer:", error);
      alert("Failed to save stock transfer.");
    }
  };

  const openRemarkModal = (section, title) => {
    if (section === "A") {
      setRemarkModalTitleA(title); // title is dynamic depending on trigger
      setIsRemarkModalOpenA(true);
    }
    if (section === "B") {
      setRemarkModalTitleB(title);
      setIsRemarkModalOpenB(true);
    }
    if (section === "C") {
      setRemarkModalTitleC(title);
      setIsRemarkModalOpenC(true);
    }
  };

  const [editMode, setEditMode] = useState({
    A: false,
    B: false,
    C: false,
  });

  const handleSectionEdit = (section) => {
    if (section === "A") {
      setIsEditingSectionA(true); // Make inputs editable
      setIsSectionAChanged(true); // Enable Submit & Clear
    } else if (section === "B") {
      setIsEditingSectionB(true);
      setIsSectionBChanged(true);
    } else if (section === "C") {
      setIsEditingSectionC(true);
      setIsSectionCChanged(true);
    }
  };

  // Create this ref at the top of your component
  const previewModalRef = useRef(null);
  const eSalesRef = useRef(null);
  const initialLoadRef = useRef(true);
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  const [isShowingAlert, setIsShowingAlert] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const saleQtyRef = useRef(null);
  const stockInwardRef = useRef(null);
  const stockInwardStoresRef = useRef(null);
  const stockOutwardRef = useRef(null);
  const submitButtonCRef = useRef(null);
  const submitButtonAllRef = useRef(null);
  const previewBtnRef = useRef(null);

  const [hoverNextDate, setHoverNextDate] = useState(false);
  const [hoverPrevDate, setHoverPrevDate] = useState(false);
  const [isFreshDate, setIsFreshDate] = useState(false);

  const [reportDate, setReportDate] = useState(""); // default empty
  // Inside your component:
  const firstLoadRef = useRef(true);
  const hasMounted = useRef(false);

  const [isSectionAChanged, setIsSectionAChanged] = useState(false);
  const [isSectionBChanged, setIsSectionBChanged] = useState(false);
  const [isSectionCChanged, setIsSectionCChanged] = useState(false);

  const [isSectionASubmitted, setIsSectionASubmitted] = useState(false);
  const [isSectionBSubmitted, setIsSectionBSubmitted] = useState(false);
  const [isSectionCSubmitted, setIsSectionCSubmitted] = useState(false);

  const [dayAchievedPercent, setDayAchievedPercent] = useState(0);
  const [stockModalType, setStockModalType] = useState("inward"); // "inward" or "outward"

  // const handleUpload = async () => {
  //   if (!file) return alert("Please choose a file first.");
  //   if (!docType) return alert("Please select a document type.");
  //   if (!selectedStore) return alert("Please select a store.");

  //   const formData = new FormData();
  //   formData.append("docType", docType);
  //   formData.append("userID", selectedStore); // ✅ add storeID
  //   formData.append("file", file);

  //   try {
  //     const response = await fetch(
  //       `${API_BASE_URL}/api/import_target_data.php`,
  //       {
  //         method: "POST",
  //         body: formData,
  //       }
  //     );

  //     const result = await response.json();
  //     console.log(result);

  //     if (result.success) {
  //       alert(
  //         `✅ Upload successful!\nInserted: ${result.inserted}, Updated: ${result.updated}`
  //       );
  //     } else {
  //       alert("❌ Upload failed: " + result.message);
  //     }
  //   } catch (err) {
  //     console.error("Upload error:", err);
  //     alert("Error uploading file: " + err.message);
  //   }
  // };
  const handleUpload = async () => {
    if (!file) return alert("Please choose a file first.");
    if (!docType) return alert("Please select a document type.");

    const formData = new FormData();
    formData.append("docType", docType);
    // ✅ No need to send storeID anymore, backend resolves store from Excel
    formData.append("file", file);

    try {
      setIsUploading(true);   // ← show blur overlay
      const response = await fetch(
        `${API_BASE_URL}/api/import_target_data.php`,
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();
      console.log(result);

      if (result.success) {
        alert(
          `✅ Upload successful!\nInserted: ${result.inserted}, Updated: ${result.updated}`
        );
      } else {
        alert("❌ Upload failed: " + result.message);
      }
    } catch (err) {
      console.error("Upload error:", err);
      alert("Error uploading file: " + err.message);
    } finally {
      setIsUploading(false);  // ← hide blur overlay
    }
  };


  const handleRowClick = (row) => {
    setSelectedRow(row);

    // Set selected date too if needed
    setSelectedDate(row.date);

    // if (visibleSection === "A") {
    //   console.log("Section A raw row.data keys:", Object.keys(row.data));
    //   console.log("Section A row.data full:", row.data);
    //   setOpeningCash(row.data["Opening Store Cash Balance (₹)"] || "");
    //   setCashSalesA(row.data["Cash Sales for the Day (₹)"] || "");
    //   setCashDeposited(row.data["Cash Deposited Today (₹)"] || "");
    //   setClosingCash(row.data["Closing Cash Balance (₹)"] || "");
    // }

    // if (visibleSection === "B") {
    //   setCashSalesB(row.data["Cash Sales (₹)"] || "");
    //   setESales(row.data["E-Sales (₹)"] || "");
    //   setGvRedemption(row.data["GV Redemption (₹)"] || "");
    //   setDayTarget(row.data["Day Target (₹)"] || "");
    //   setTotalSales(row.data["Total Sales (₹)"] || "");
    //   setMtdTarget(row.data["MTD Target (₹)"] || "");
    //   setMtdSales(row.data["MTD Sales (₹)"] || "");
    //   setBacklog(row.data["Backlog (₹)"] || "");
    //   setMonthTarget(row.data["Month Target (₹)"] || "");
    //   setAchievedPercent(row.data["Achieved %"] || "");
    //   setTotalBills(row.data["Total Bills"] || "");
    //   setManualBillNo(row.data["Manual Bill No"] || "");
    //   setWalkins(row.data["Walkins"] || "");
    //   setHeadcount(row.data["Headcount"] || "");
    // }

    // if (visibleSection === "C") {
    //   setOpeningStock(row.data["Opening Stock"] || "");
    //   setStockInward(row.data["Stock Inward from HO"] || "");
    //   setSaleQty(row.data["Sale Quantity"] || "");
    //   setClosingStock(row.data["Closing Stock"] || "");
    //   setStockInwardStores(row.data["Stock Inward from Other Stores"] || "");
    //   setStockOutward(row.data["Stock Outward to Other Stores"] || "");
    // }
  };

  //aug 18

  const [showSectionA, setShowSectionA] = useState(true);
  const [showSectionB, setShowSectionB] = useState(true);
  const [showSectionC, setShowSectionC] = useState(true);

  const location = useLocation();
  const storeName = location.state?.storeName ?? "N/A"; // ✅ Use optional chaining
  let userID = location.state?.userID ?? "N/A"; // ✅ Use optional chaining
  // ✅ Normalize once
  const isAdmin = Number(location.state?.IsAdmin ?? 0);
  // ✅ override userID if admin and store selected
  if (isAdmin === 1 && selectedStore) {
    const matchedStore = stores.find((s) => s.StoreName === selectedStore);
    if (matchedStore) {
      console.log(
        "selected store ID: ",
        matchedStore.UserID,
        typeof matchedStore.UserID
      );
      userID = matchedStore.UserID;
    }
  }

  console.log("Dashboard store name:", storeName, isAdmin, typeof isAdmin); // ✅ Check this

  // ⬅️ Add this at the top of your component
  const cashSalesRef = useRef(null);

  const cashDepositedRef = useRef(null);

  const [submittedRows, setSubmittedRows] = useState([]);

  const [visibleSection, setVisibleSection] = useState(""); // "", "A", "B", or "C"

  const getTodayDateString = () => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // format: YYYY-MM-DD
  };

  const [selectedDate, setSelectedDate] = useState(getTodayDateString());

  const [submittedDates, setSubmittedDates] = useState([]); // e.g. ["2025-07-18", "2025-07-17"]

  const [isReadOnly, setIsReadOnly] = useState(false); // ✅ Add this state

  const [isOpeningStockReadOnly, setIsOpeningStockReadOnly] = useState(false); //today

  // const [isCashSalesBReadOnly, setIsCashSalesBReadOnly] = useState(false);
  // const [isESalesReadOnly, setIsESalesReadOnly] = useState(false);
  // const [isGVRedemptionReadOnly, setIsGVRedemptionReadOnly] = useState(false);
  // const [isDayTargetReadOnly, setIsDayTargetReadOnly] = useState(false);
  // const [isTotalSalesReadOnly, setIsTotalSalesReadOnly] = useState(false);
  // const [isMTDTargetReadOnly, setIsMTDTargetReadOnly] = useState(false);
  // const [isMTDSalesReadOnly, setIsMTDSalesReadOnly] = useState(false);
  // const [isBacklogReadOnly, setIsBacklogReadOnly] = useState(false);
  // const [isMonthTargetReadOnly, setIsMonthTargetReadOnly] = useState(false);
  // const [isAchievedPercentReadOnly, setIsAchievedPercentReadOnly] = useState(false);
  // const [isTotalBillsReadOnly, setIsTotalBillsReadOnly] = useState(false);
  // const [isManualBillNoReadOnly, setIsManualBillNoReadOnly] = useState(false);
  // const [isWalkinsReadOnly, setIsWalkinsReadOnly] = useState(false);
  // const [isHeadcountReadOnly, setIsHeadcountReadOnly] = useState(false); //today

  const fetchAllSectionData = () => {
    fetchSectionData("A");
    fetchSectionData("B");
    fetchSectionData("C");
  }; //today

  // Export Excel for a specific section
  const handleExportSectionExcel = (section) => {
    if (!selectedDate) {
      alert("Please select a date first");
      return;
    }

    const url = `${API_BASE_URL}/api/export_excel_sections.php?date=${selectedDate}&userid=${userID}&section=${section}`;
    // ✅ Open in new tab so it triggers download
    window.open(url, "_blank");
  };

  const handleExportMonthTarget = async () => {
    // console.log("Selected date :", selectedDate,monthTarget);

    if (!monthTargetData.length) {
      alert("No month target data available to export.");
      return;
    }

    // 🗓️ Get selected month & year
    const selectedMonth = new Date(selectedDate).getMonth();
    const selectedYear = new Date(selectedDate).getFullYear();

    // 🔍 Filter only that month’s data
    const filteredMonthData = monthTargetData
      .filter((item) => {
        const itemDate = new Date(item.TargetDate);
        return (
          itemDate.getMonth() === selectedMonth &&
          itemDate.getFullYear() === selectedYear
        );
      })
      .map((item) => {
        const itemDate = new Date(item.TargetDate);
        const dayName = itemDate.toLocaleDateString("en-US", { weekday: "short" });
        return {
          ...item,
          Day: dayName, // ✅ Add day name here itself
        };
      });


    if (!filteredMonthData.length) {
      alert("No data found for the selected month.");
      return;
    }
    // 🧹 Remove unwanted columns
    const filteredData = filteredMonthData.map(
      ({ TargetID, UserID, ...rest }) => rest
    );

    // 🧾 Create workbook and worksheet
    const workbook = new ExcelJS.Workbook();

    const monthName = new Date(selectedDate)
      .toLocaleString("en-US", { month: "short" })
      .toUpperCase();

    const worksheet = workbook.addWorksheet(`Month_${monthName}`);
    // 🏷️ Add header row with friendly names
    const headerMapping = {
      TargetDate: "Date",
      Day: "Day",
      DayTargetValue: "Value",
      DayTargetPercent: "Daily %",
      DayTargetPcs: "T.Pcs",
      MTDTargetValue: "MTD Amt",
      MTDTargetPcs: "MTD Pcs",
      MonthTargetValue: "Mth.Tgt Amt",
      MonthTargetPcs: "Mth.Tgt Pcs",
    };

    const headers = [
      headerMapping.TargetDate,
      headerMapping.Day,
      headerMapping.DayTargetPercent,
      headerMapping.DayTargetValue,
      headerMapping.DayTargetPcs,
      headerMapping.MTDTargetValue,
      headerMapping.MTDTargetPcs,
      headerMapping.MonthTargetValue,
      headerMapping.MonthTargetPcs
    ];
    worksheet.addRow(headers);


    // // 🏷️ Add header row
    // const headers = Object.keys(filteredData[0]);
    // worksheet.addRow(headers);

    // 🧍‍♂️ Add data rows
    filteredData.forEach((row) => {
      // 🔹 Format TargetDate to dd-mm-yy
      const date = new Date(row.TargetDate);
      const formattedDate = `${String(date.getDate()).padStart(2, "0")}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}-${String(date.getFullYear()).slice(-2)}`;
      row.TargetDate = formattedDate;

      worksheet.addRow([
        row.TargetDate,
        row.Day,
        row.DayTargetPercent,
        row.DayTargetValue,
        row.DayTargetPcs,
        row.MTDTargetValue,
        row.MTDTargetPcs,
        row.MonthTargetValue,
        row.MonthTargetPcs
      ]);
    });


    // 🎨 Style header row
    const headerRow = worksheet.getRow(1);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF4F81BD" }, // mild blue
      };
      cell.border = {
        top: { style: "thin", color: { argb: "FFAAAAAA" } },
        bottom: { style: "thin", color: { argb: "FFAAAAAA" } },
        left: { style: "thin", color: { argb: "FFAAAAAA" } },
        right: { style: "thin", color: { argb: "FFAAAAAA" } },
      };
    });

    // 🧱 Apply borders and alignment to all data rows
    worksheet.eachRow((row, rowNumber) => {
      row.eachCell((cell) => {
        cell.border = {
          top: { style: "thin", color: { argb: "FFD9D9D9" } },
          bottom: { style: "thin", color: { argb: "FFD9D9D9" } },
          left: { style: "thin", color: { argb: "FFD9D9D9" } },
          right: { style: "thin", color: { argb: "FFD9D9D9" } },
        };
        cell.alignment = { vertical: "middle", horizontal: "center" };
      });
    });

    // 📏 Auto-fit column widths
    worksheet.columns.forEach((col) => {
      let maxLength = 0;
      col.eachCell({ includeEmpty: true }, (cell) => {
        const val = cell.value ? cell.value.toString().length : 10;
        if (val > maxLength) maxLength = val;
      });
      col.width = maxLength + 2;
    });

    // 🧊 Freeze header row
    worksheet.views = [{ state: "frozen", ySplit: 1 }];

    // 🔢 Apply decimal formatting only where needed
    // worksheet.eachRow((row, rowNumber) => {
    //   if (rowNumber === 1) return; // skip header
    //   row.eachCell((cell) => {
    //     if (!isNaN(cell.value) && cell.value !== null && cell.value !== "") {
    //       const num = parseFloat(cell.value);
    //       if (num % 1 !== 0) cell.numFmt = "#,##0.00"; // apply .00 only if decimal
    //     }
    //   });
    // });

    // 💾 Save file
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), `Month_Target_Report_${monthName}.xlsx`);
  };

  const handleExportExcel = () => {
    if (!selectedDate) {
      alert("Please select a date first");
      return;
    }

    // If Admin and no store selected → ALL stores
    const finalUserID =
      isAdmin === 1 && selectedStore.trim() === "" ? "all" : userID;

    if (finalUserID === "all") {
      // Call ONLY export_excel_all
      window.open(
        `${API_BASE_URL}/api/export_excel_all.php?date=${selectedDate}&userid=${finalUserID}`
      );
    } else {
      // Call ONLY export_excel
      window.open(
        `${API_BASE_URL}/api/export_excel.php?date=${selectedDate}&userid=${finalUserID}`
      );
    }
  };

  const handleExportPDF = () => {
    if (!selectedDate) {
      alert("Please select a date first");
      return;
    }
    window.open(
      `${API_BASE_URL}/api/export_pdf.php?date=${selectedDate}&userid=${userID}`
    );
  };

  const [targetData, setTargetData] = useState([]);
  const [monthTargetData, setMonthTargetData] = useState([]);

  const [closingCashWarning, setClosingCashWarning] = useState("");

  const dateInputRef = useRef(null);

  const isStoredDataAvailable = (section) => {
    const selectedISO = selectedDate
      ? new Date(selectedDate).toISOString().split("T")[0]
      : "";

    const sectionData = rawSectionData[section] || [];
    return sectionData.some((row) => row.Date === selectedISO);
  };

  const formatZero = (value) => {
    const num = parseFloat(value);
    return !value || isNaN(num) || num === 0 ? "-" : value;
  };

  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/", { replace: true }); // Go back to Login
  };

  useEffect(() => {
    if (dateInputRef.current) {
      dateInputRef.current.focus();
    }
  }, []);

  useEffect(() => {
    setCashSalesB(cashSalesA);
  }, [cashSalesA]);

  useEffect(() => {
    const sales = parseFloat(mtdSales) || 0;
    const target = parseFloat(mtdTarget) || 0;

    if (target > 0) {
      const percent = (sales / target) * 100;
      setMtdAchievedPercent(percent.toFixed(2));
    } else {
      setMtdAchievedPercent("");
    }
  }, [mtdSales, mtdTarget]);

  useEffect(() => {
    if (!totalSales || !dayTarget) {
      setDayAchievedPercent(0);
      return;
    }
    const percent = (parseFloat(totalSales) / parseFloat(dayTarget)) * 100;
    setDayAchievedPercent(percent.toFixed(2)); // round to 2 decimals
  }, [totalSales, dayTarget]);

  useEffect(() => {
    // Reset Section A
    setOpeningCash("");
    setCashSalesA("");
    setSelectedBank("");
    setCashDeposited("");
    setClosingCash("");

    // Reset Section B
    setCashSalesB("");
    setDayTarget("");
    setMtdSales("");
    setAchievedPercent("");
    setWalkins("");
    setESales("");
    setGvRedemption("");
    setTotalSales("");
    setBacklog("");
    setMtdTarget("");
    setMonthTarget("");
    setTotalBills("");
    setManualBillNo("");
    setHeadcount("");

    // Reset Section C
    setOpeningStock("");
    setStockInward("");
    setStockOutward("");
    setSaleQty("");
    setClosingStock("");
  }, [selectedDate]);

  const [sectionAData, setSectionAData] = useState({});
  const [isOpeningCashReadOnly, setIsOpeningCashReadOnly] = useState(false);

  // Handles validation and formatting
  const handleValidatedInput = (e, setter) => {
    let value = e.target.value;

    // ✅ If cleared, leave it empty
    if (value === "") {
      setter("");
      return;
    }

    // Remove non-digit/non-dot characters
    value = value.replace(/[^\d.]/g, "");

    const parts = value.split(".");

    // Return if more than one decimal
    if (parts.length > 2) return;

    // Limit digits before decimal
    if (parts[0].length > 7) return;

    // Limit to 2 decimal digits
    if (parts[1] && parts[1].length > 2) {
      parts[1] = parts[1].slice(0, 2);
      value = parts.join(".");
    }

    // ✅ Only auto-add .00 if exactly 6 digits entered without decimal
    if (parts.length === 1 && parts[0].length === 7) {
      value = parseFloat(parts[0]).toFixed(2);
    }

    setter(value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent form submission

      const form = e.target.form;
      const index = Array.prototype.indexOf.call(form, e.target);

      // Focus next input
      const next = form.elements[index + 1];
      if (next && next.tagName === "INPUT") {
        next.focus();
      }
    }
  };

  const getPreviousDate = (dateStr) => {
    const date = new Date(dateStr);
    date.setDate(date.getDate() - 1);
    return date.toISOString().slice(0, 10); // format YYYY-MM-DD
  };

  const formattedSelectedDate = selectedDate
    ? new Date(selectedDate).toISOString().slice(0, 10) // ✅ "2025-07-11"
    : new Date().toISOString().slice(0, 10);

  useEffect(() => {
    // const closing = parseFloat(closingCash);
    // if (!isNaN(closing) && closing > 10000) {
    //   setClosingCashWarning(
    //     "⚠️ Closing cash balance exceeds ₹10,000. Please deposit the excess cash."
    //   );
    // } else {
    //   setClosingCashWarning("");
    // }
  }, [closingCash]);
  const fetchSectionData = async (section) => {
    const url = `${API_BASE_URL}/api/get_eod_data.php`;

    try {
      console.log(`=== Fetching Section ${section} Data ===`);
      console.log("Request payload:", { section, userID, selectedDate });

      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ section, userID, selectedDate }),
      });

      console.log("Response status:", res.status);

      if (!res.ok) throw new Error(`Server returned ${res.status}`);

      const data = await res.json();
      console.log(`Backend returned for section ${section}:`, data);

      if (data.success && Array.isArray(data.data)) {
        if (data.stores) setStores(data.stores);

        // Store bankData separately
        if (data.bankData) {
          setBankData(data.bankData);
        }
        setRawSectionData((prev) => ({
          ...prev,
          [section]: data.data,
        }));

        // ============================
        // Determine Selected Date for Section A (latest)
        // ============================
        if (section === "A" && data.data.length > 0 && firstLoadRef.current) {
          const dates = data.data.map((item) => new Date(item.Date));
          const maxDate = new Date(Math.max(...dates));
          const formattedDate = maxDate.toISOString().split("T")[0];
          setSelectedDate(formattedDate);
          firstLoadRef.current = false;
        }

        // ============================
        // Button State Logic
        // ============================
        if (section === "A") {
          const submitted = data.submitted?.sectionA || false;
          const hasData = data.data.length > 0;

          setIsSectionASubmitted(submitted);

          if (submitted && hasData) {
            // Already submitted → read-only
            setIsEditingSectionA(false);
            setIsSectionAChanged(false);
          } else {
            // New date → all disabled initially
            setIsEditingSectionA(false);
            setIsSectionAChanged(false);
          }
        }

        if (section === "B") {
          const submitted = data.submitted?.sectionB || false;
          const hasData = data.data.length > 0;

          setIsSectionBSubmitted(submitted);

          if (submitted && hasData) {
            setIsEditingSectionB(false);
            setIsSectionBChanged(false);
          } else {
            setIsEditingSectionB(false);
            setIsSectionBChanged(false);
          }

          if (Array.isArray(data.targetData)) setTargetData(data.targetData);
          if (Array.isArray(data.targetMonthData))
            setMonthTargetData(data.targetMonthData);
          if (data.mtdSales !== undefined) {
            setMtdSales(data.mtdSales || "0.00");
            setBackendMtdSales(data.mtdSales || "0.00");
          }
        }

        if (section === "C") {
          const submitted = data.submitted?.sectionC || false;
          const hasData = data.length > 0;

          setIsSectionCSubmitted(submitted);

          if (submitted && hasData) {
            setIsEditingSectionC(false);
            setIsSectionCChanged(false);
          } else {
            setIsEditingSectionC(false);
            setIsSectionCChanged(false);
          }
        }
      } else {
        console.warn(`⚠️ Failed to fetch section ${section} data`);
      }
    } catch (err) {
      console.error(`❌ Fetch failed for section ${section}:`, err);
    }
  };

  useEffect(() => {
    fetchSectionData("A"); // get last submitted date
  }, []);

  const handleSectionClick = (section) => {
    console.log(section);
    setVisibleSection(section);
    setSubmittedRows([]);
    console.log("📌 selectedDate before fetch:", selectedDate);

    fetch(`${API_BASE_URL}/api/get_eod_data.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ section, userID, selectedDate }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success && Array.isArray(data.data)) {
          console.log(`✅ Section ${section} Data:`, data.data);

          // ✅ Save raw data per section
          setRawSectionData((prev) => ({
            ...prev,
            [section]: data.data,
          }));
          // ✅ Always trust backend
          if (data.mtdSales !== undefined) {
            setBackendMtdSales(data.mtdSales || "0.00");
          }

          const selectedFormattedDate = selectedDate
            ? new Date(selectedDate).toISOString().split("T")[0]
            : "";

          const formattedRows = data.data.map((row) => {
            const date = row.Date;
            let sectionData = {};

            const formatValue = (val) => {
              const num = parseFloat(val);
              if (val === null || val === undefined || val === "") return "-";
              if (!isNaN(num) && num === 0) return "-";
              return val;
            };

            if (section === "A") {
              sectionData = {
                "Opening Store Cash Balance (₹)": row.OpenCashBal,
                "Cash Sales for the Day (₹)": row.CashSales,
                "Cash Deposited Today (₹)": row.CashDeposit,
                "Closing Cash Balance (₹)": row.CloseCashBal,
                "Cash Adjustment (₹)": row.CashAdjustment,
                "Remarks of A": row.RemarksA,
              };

              if (selectedDate === "2025-07-01") {
                // If nothing saved yet → keep blank for input
                if (!row.OpenCashBal) {
                  sectionData["Opening Store Cash Balance (₹)"] = "";
                }
              } else {
                // From July 2 onwards, carry forward yesterday’s closing if no opening saved
                const yesterdayData = (rawSectionData?.A || []).find(
                  (r) => r.Date === getPreviousDate(selectedDate)
                );

                if (!row.OpenCashBal && yesterdayData) {
                  sectionData["Opening Store Cash Balance (₹)"] =
                    yesterdayData.CloseCashBal || "";
                }
              }

              setSectionAData(sectionData);
            }

            if (section === "B") {
              sectionData = {
                "Cash Sales (₹)": formatValue(row.CashSalesB),
                "E-Sales (₹)": formatValue(row.ESales),
                "GV Redemption (₹)": formatValue(row.GV),
                "Day Target (₹)": formatValue(row.DayTarget),
                "Total Sales (₹)": formatValue(row.TotalSales),
                "MTD Target (₹)": formatValue(row.MTDTarget),
                "MTD Sales (₹)": formatValue(row.MTDSales),
                "Backlog (₹)": formatValue(row.Backlog),
                "Month Target (₹)": formatValue(row.MonthTarget),
                "Achieved %": formatValue(row.Achieved),
                "Total Bills": formatValue(row.TotalBills),
                "Manual Bill No": formatValue(row.ManualBillNo),
                Walkins: formatValue(row.WalkIns),
                Headcount: formatValue(row.HeadCount),
                "Remarks of B": row.RemarksB,
                "E-Sales Adjustment (₹)": formatValue(
                  row.ESalesAdjustment || 0
                ), // ✅ new
                "E-Sales Adjustment Remark": row.ESalesAdjustmentRemark || "", // ✅ new
              };
              // ✅ Step 1: Get targetMonthData
              const targetData = data.targetMonthData?.find(
                (t) => t.TargetDate === row.Date
              );
              console.log("Target found:", targetData);

              // ✅ Step 2: Add extra value (e.g., DayTargetPercent)
              if (targetData) {
                // 🔹 Get weekday name from TargetDate
                const dayName = new Date(
                  targetData.TargetDate
                ).toLocaleDateString("en-US", {
                  weekday: "long",
                });

                sectionData["Day"] = dayName; // ✅ Example: "Monday"
                sectionData["Day Target %"] = formatValue(
                  targetData.DayTargetPercent
                );
                sectionData["Day Value (₹)"] = formatValue(
                  targetData.DayTargetValue
                );
                sectionData["T.Pcs"] = formatValue(targetData.DayTargetPcs);
                sectionData["MTD Value (₹)"] = formatValue(
                  targetData.MTDTargetValue
                );
                sectionData["MTD T.Pcs"] = formatValue(targetData.MTDTargetPcs);
                sectionData["Month T.Value (₹)"] = formatValue(
                  targetData.MonthTargetValue
                );
                sectionData["Month T.Pcs"] = formatValue(
                  targetData.MonthTargetPcs
                );
              }
              if (date === selectedFormattedDate) {
                const currentSelectedB = row;
                const targetData = rawSectionData?.B_targetData ?? [];
                const fallback = targetData[0] || {};

                setESales(currentSelectedB.ESales || "0.00");
                setGvRedemption(currentSelectedB.GV || "0.00");
                setDayTarget(currentSelectedB.DayTarget || "0.00");
                setTotalSales(currentSelectedB.TotalSales || "0.00");

                // ✅ E-Sales Adjustment
                setESalesAdjustment(
                  currentSelectedB.ESalesAdjustment || "0.00"
                );
                // setESalesAdjustmentRemark(currentSelectedB.ESalesAdjustmentRemark || "");

                // ✅ MTD Sales logic
                const selectedDay = new Date(selectedFormattedDate).getDate();
                const selectedMonth = new Date(
                  selectedFormattedDate
                ).getMonth();
                const selectedYear = new Date(
                  selectedFormattedDate
                ).getFullYear();

                // Sum TotalSales for current month up to selectedDate
                // const mtdSalesValue = data.data
                //   .filter((r) => {
                //     const d = new Date(r.Date);
                //     return (
                //       d.getFullYear() === selectedYear &&
                //       d.getMonth() === selectedMonth &&
                //       d.getDate() <= selectedDay
                //     );
                //   })
                //   .reduce((sum, r) => sum + parseFloat(r.TotalSales || 0), 0);

                // setMtdSales(mtdSalesValue.toFixed(2));

                setMtdTarget(currentSelectedB.MTDTarget || "0.00");
                setBacklog(currentSelectedB.Backlog || "0.00");

                setMonthTarget(
                  currentSelectedB.MonthTarget ||
                  fallback.MonthTargetValue ||
                  "0.00"
                );

                setAchievedPercent(currentSelectedB.Achieved || "0.00");
                setTotalBills(currentSelectedB.TotalBills || "");
                setManualBillNo(currentSelectedB.ManualBillNo || "");
                setWalkins(currentSelectedB.WalkIns || "");
                setHeadcount(currentSelectedB.HeadCount || "");
              }
            }

            if (section === "C") {
              sectionData = {
                "Opening Stock": formatValue(row.OpeningStock),
                "Stock Inward from HO": formatValue(row.StockInwHO),
                "Stock Inward from Other Stores": formatValue(
                  row.StockInwStore
                ),
                "Stock Outward to HO": formatValue(row.StockOutwHO),
                "Stock Outward to Other Stores": formatValue(
                  row.StockOutwStore
                ),
                "Sale Quantity": formatValue(row.SaleQty),
                "Closing Stock": formatValue(row.ClosingStock),
                "Stock Adjustment": formatValue(row.StockAdjustment), // ✅ NEW
                "Remarks of C": formatValue(row.RemarksC),
                "Stock Transfer Invoice No.": formatValue(
                  [row.StockTransferInwNo, row.StockTransferOutwNo]
                    .filter(Boolean)
                    .join(", ")
                ),
                "Stock Transfer Invoice Date": formatValue(
                  row.StockTransferDate
                ),
              };

              if (date === selectedFormattedDate) {
                setOpeningStock(row.OpeningStock ?? "");
                // setStockInward(row.StockInwHO ?? "");
                setStockInward(row.StockInwHO);

                setSaleQty(row.SaleQty ?? "");
                setClosingStock(row.ClosingStock ?? "");
                setStockOutward(
                  row.StockOutwHO > 0
                    ? row.StockOutwHO
                    : row.StockOutwStore > 0
                      ? row.StockOutwStore
                      : ""
                );
                setStockAdjustment(row.StockAdjustment ?? ""); // ✅ NEW

                // ✅ Lock the field if 01-07-2025 and data is present
                if (
                  selectedDate === "2025-07-01" &&
                  row.OpeningStock !== null &&
                  row.OpeningStock !== undefined &&
                  row.OpeningStock !== ""
                ) {
                  setIsOpeningStockReadOnly(true);
                }
              }
            }

            return {
              date,
              data: sectionData,
            };
          });

          setSubmittedRows(formattedRows);

          const exists = formattedRows.some(
            (row) => row.date === selectedFormattedDate
          );
          setIsReadOnly(exists);
        }
      })
      .catch((err) => {
        console.error(`❌ Failed to fetch Section ${section} data:`, err);
      });
  };

  // useEffect(() => {
  //   fetch(`${API_BASE_URL}/api/get_eod_data.php`, {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify({ section: "A", selectedDate }), // 👈 your existing request
  //   })
  //     .then((res) => res.json())
  //     .then((data) => {
  //       console.log("✅ Section A Data:", data);

  //       if (data.success) {
  //         setSectionAData(data.data);

  //         // ✅ populate stores for dropdown
  //         if (data.stores) {
  //           setStores(data.stores);
  //         }
  //       }
  //     })
  //     .catch((err) => console.error("Error fetching section A:", err));
  // }, [selectedDate]);
  //aug19

  //a
  useEffect(() => {
    if (selectedDate) {
      handleDateCheck();
    }
  }, [selectedDate, rawSectionData]);

  useEffect(() => {
    fetchAllSectionData(); // ✅ cleaner: single function call
  }, [selectedDate, userID]); //today

  // When date changes, re-fetch B to recalculate MTD Sales
  // useEffect(() => {
  //   if (selectedDate) {
  //     fetchSectionData("B");
  //   }
  // }, [selectedDate]);
  const hasAlertedRef = useRef(false);
  const lastValidDateRef = useRef(null); // ✅ store last valid date

  const handleDateCheck = () => {
    const selectedISO = new Date(selectedDate).toISOString().split("T")[0];

    const sectionAData = rawSectionData.A || [];
    const sectionBData = rawSectionData.B || [];
    const sectionCData = rawSectionData.C || [];

    // ✅ Find all dates where A, B, and C exist (fully completed)
    const completedDates = sectionAData
      .map((r) => r.Date?.split("T")[0])
      .filter((d) => {
        const b = sectionBData.some((x) => x.Date?.split("T")[0] === d);
        const c = sectionCData.some((x) => x.Date?.split("T")[0] === d);
        return b && c;
      })
      .sort();

    const lastCompletedDate =
      completedDates.length > 0
        ? completedDates[completedDates.length - 1]
        : null;

    const skipValidationUsers = ["107", "108", "109"];

    // ✅ If this selected date is already completed — allow it silently
    if (completedDates.includes(selectedISO)) {
      hasAlertedRef.current = false;
      lastValidDateRef.current = selectedISO;
      // continue your normal population logic here...
      // no blocking alert
    } else {
      // ✅ Compare only when trying to go *beyond* the last completed date
      // Skip validation for selected userIDs
      if (!skipValidationUsers.includes(String(userID))) {
        if (lastCompletedDate && !hasAlertedRef.current) {
          const nextAllowedDate = new Date(lastCompletedDate);
          nextAllowedDate.setDate(nextAllowedDate.getDate() + 1);

          if (new Date(selectedISO) > nextAllowedDate) {
            hasAlertedRef.current = true;
            alert(
              "Please submit all 3 sections (A, B, and C) for the previous date before moving to the next date."
            );

            setSelectedDate(lastCompletedDate);
            return;
          }
        }
      }



      // ✅ Reset alert flag when within range
      if (new Date(selectedISO) <= new Date(lastCompletedDate)) {
        hasAlertedRef.current = false;
      }
    }

    // ✅ Continue your existing logic below (populate sections, etc.)
    const prevDateObj = new Date(selectedISO);
    prevDateObj.setDate(prevDateObj.getDate() - 1);
    const prevISO = prevDateObj.toISOString().split("T")[0];

    const currentSelectedA = sectionAData.find(
      (r) => r.Date?.split("T")[0] === selectedISO
    );
    const currentSelectedB = sectionBData.find(
      (r) => r.Date?.split("T")[0] === selectedISO
    );
    const currentSelectedC = sectionCData.find(
      (r) => r.Date?.split("T")[0] === selectedISO
    );

    const prevRow = sectionAData.find((r) => r.Date?.split("T")[0] === prevISO);
    const PrevDayOpeningCash = prevRow?.CloseCashBal || "";

    const prevRowC = sectionCData.find(
      (r) => r.Date?.split("T")[0] === prevISO
    );
    const PrevDayOpeningStock = prevRowC?.ClosingStock || "";

    const matchedTarget = targetData.find(
      (t) => t.TargetDate?.split("T")[0] === selectedISO
    );

    // ... continue rest of your logic

    // ✅ SECTION A
    if (currentSelectedA) {
      // Submitted date — populate values from existing data
      setOpeningCash(currentSelectedA?.OpenCashBal ?? PrevDayOpeningCash);
      setCashSalesA(
        currentSelectedA?.CashSales != null &&
          currentSelectedA?.CashSales !== ""
          ? parseFloat(currentSelectedA.CashSales).toFixed(2)
          : "0.00"
      );
      setCashDeposited(
        currentSelectedA?.CashDeposit != null
          ? parseFloat(currentSelectedA.CashDeposit).toFixed(2)
          : "0.00"
      );
      setSelectedBank(
        currentSelectedA?.DepositedBank && currentSelectedA.DepositedBank !== null
          ? currentSelectedA.DepositedBank
          : bankData[0]?.banknameshort || ""
      );
      setCashAdjustment(
        currentSelectedA?.CashAdjustment != null
          ? parseFloat(currentSelectedA.CashAdjustment).toFixed(2)
          : "0.00"
      );
      setClosingCash(
        currentSelectedA?.CloseCashBal != null
          ? parseFloat(currentSelectedA.CloseCashBal).toFixed(2)
          : "0.00"
      );
      // Enable Edit button for submitted date
      setIsEditingSectionA(false);
      setIsSectionAChanged(false);
    } else {
      // New date — start with previous day opening cash, rest empty
      setOpeningCash(PrevDayOpeningCash);
      setCashSalesA("");
      setCashDeposited("");
      setSelectedBank("");
      setCashAdjustment("");
      setClosingCash("");
      // Disable all buttons initially
      setIsEditingSectionA(false);
      setIsSectionAChanged(false);
    }

    // ✅ SECTION B
    if (currentSelectedB) {
      setCashSalesB(
        currentSelectedB?.CashSalesB !== null &&
          currentSelectedB?.CashSalesB !== undefined
          ? parseFloat(currentSelectedB.CashSalesB).toFixed(2)
          : "0.00"
      );

      setESales(currentSelectedB?.ESales || "0.00");
      setGvRedemption(currentSelectedB?.GV || "0.00");

      setDayTarget(
        currentSelectedB?.DayTarget || matchedTarget?.DayTargetValue || "0.00"
      );
      setTotalSales(currentSelectedB?.TotalSales || "0.00");
      setOriginalTotalSales(currentSelectedB?.TotalSales || "0.00");
      setMtdTarget(
        currentSelectedB?.MTDTarget || matchedTarget?.MTDTargetValue || "0.00"
      );
      setMtdSales(currentSelectedB?.MTDSales || "0.00");
      setBacklog(currentSelectedB?.Backlog || "0.00");
      setMonthTarget(
        currentSelectedB?.MonthTarget ||
        matchedTarget?.MonthTargetValue ||
        "0.00"
      );
      setAchievedPercent(currentSelectedB?.Achieved || "0.00");
      setTotalBills(currentSelectedB?.TotalBills || "0");
      setManualBillNo(currentSelectedB?.ManualBillNo || "");
      setWalkins(currentSelectedB?.WalkIns || "0");
      setHeadcount(currentSelectedB?.HeadCount || "0");

      // ✅ E-SALES ADJUSTMENT
      setESalesAdjustment(
        currentSelectedB?.ESalesAdjustment !== null &&
          currentSelectedB?.ESalesAdjustment !== undefined
          ? parseFloat(currentSelectedB.ESalesAdjustment).toFixed(2)
          : "0.00"
      );
      // setESalesAdjustmentRemark(currentSelectedB?.ESalesAdjustmentRemark || "");
    } else {
      // Reset / default values
      setESales("");
      setGvRedemption("");
      setDayTarget(matchedTarget?.DayTargetValue || "0.00");
      setMtdTarget(matchedTarget?.MTDTargetValue || "0.00");
      setMtdSales(mtdSales || "0.00");
      setMonthTarget(matchedTarget?.MonthTargetValue || "0.00");
      setTotalBills("");
      setManualBillNo("");
      setWalkins("");
      setHeadcount("");

      // ✅ Reset E-Sales Adjustment
      setESalesAdjustment("");
      // setESalesAdjustmentRemark("");
    }

    // ✅ SECTION C
    if (currentSelectedC) {
      setOpeningStock(currentSelectedC?.OpeningStock || "0");
      // setStockInward(currentSelectedC?.StockInwHO || "0");
      setStockInward(
        currentSelectedC?.StockInwHO || currentSelectedC?.StockInwStore || "0"
      );
      // setStockInwardStores(currentSelectedC?.StockInwStore || "0");
      setStockOutward(
        currentSelectedC?.StockOutwHO || currentSelectedC?.StockOutwStore || "0"
      );
      setStockAdjustment(currentSelectedC?.StockAdjustment || "0");
      setSaleQty(currentSelectedC?.SaleQty || "0");
      setClosingStock(currentSelectedC?.ClosingStock || "0");
    } else {
      setOpeningStock(PrevDayOpeningStock);
      setStockInward("");
      setStockOutward("");
      setStockAdjustment("");
      setSaleQty("");
      // setClosingStock("");
    }

    setIsReadOnly(!!(currentSelectedA || currentSelectedB || currentSelectedC));

    // 👇 Always show all sections
    setShowSectionA(true);
    setShowSectionB(true);
    setShowSectionC(true);
  };

  useEffect(() => {
    if (openingCash && cashSalesA && cashDeposited) {
      let adjustment = 0;

      if (cashAdjustment) {
        // Remove spaces and parse number with optional + or -
        const parsed = parseFloat(cashAdjustment.replace(/\s/g, ""));
        if (!isNaN(parsed)) adjustment = parsed;
      }

      setClosingCash(
        (parseFloat(openingCash) || 0) +
        (parseFloat(cashSalesA) || 0) -
        (parseFloat(cashDeposited) || 0) +
        adjustment
      );
    }
    // ✅ else do nothing, leave previous closingCash intact
  }, [openingCash, cashSalesA, cashDeposited, cashAdjustment]);

  // useEffect(() => {
  //   if (Sales) {
  //     let adjustment = 0;

  //     if (eSalesAdjustment) {
  //       // Remove spaces and parse number with optional + or -
  //       const parsed = parseFloat(eSalesAdjustment.toString().replace(/\s/g, ""));
  //       if (!isNaN(parsed)) adjustment = parsed;
  //     }

  //     setESalesAdjustment(
  //       (parseFloat(eSales) || 0) + adjustment
  //     );
  //   }
  //   // ✅ else do nothing — leave previous adjustedESales intact
  // }, [eSales, eSalesAdjustment]);

  // useEffect(() => {
  //   if (!selectedDate) return;

  //   const fetchPreviousDayClosing = async () => {
  //     const selected = new Date(selectedDate);
  //     selected.setDate(selected.getDate() - 1);
  //     const prevDate = selected.toISOString().split("T")[0];

  //     try {
  //       const res = await fetch(`http://your-api/sectionA?date=${prevDate}`);
  //       const json = await res.json();

  //       const prevRow = json.find((row) => row.Date === prevDate);

  //       if (prevRow && prevRow["Closing Store Cash Balance (₹)"]) {
  //         setOpeningCash(prevRow["Closing Store Cash Balance (₹)"]);
  //       } else if (selectedDate === "2025-07-01") {
  //         setOpeningCash("549.00");
  //       } else {
  //         setOpeningCash("");
  //       }
  //     } catch (err) {
  //       console.error("❌ Error fetching previous day's closing cash:", err);
  //     }
  //   };

  //   fetchPreviousDayClosing();
  // }, [selectedDate]);

  useEffect(() => {
    // Total Sales = Cash Sales B + (E-Sales + E-Sales Adjustment) + GV Redemption
    const eSalesTotal =
      (parseFloat(eSales) || 0) + (parseFloat(eSalesAdjustment) || 0);
    const total =
      (parseFloat(cashSalesB) || 0) +
      eSalesTotal +
      (parseFloat(gvRedemption) || 0);
    const formattedTotal = total ? total.toFixed(2) : "";
    setTotalSales(formattedTotal);

    // Backlog = MTD Target - MTD Sales
    // if (mtdTarget && mtdSales) {
    //   setBacklog((parseFloat(mtdTarget) - parseFloat(mtdSales)).toFixed(2));
    // } else {
    //   setBacklog("");
    // }

    // Backlog = MTD Sales - MTD Target
    if (mtdTarget && mtdSales) {
      const backlogValue = parseFloat(mtdSales) - parseFloat(mtdTarget);
      // show with minus if negative, else as normal
      setBacklog(backlogValue.toFixed(2));
      // console.log("Backlog value: ",backlogValue);
    } else {
      setBacklog("");
    }

    // Achieved % = (MTD Sales / Month Target) * 100
    if (monthTarget && parseFloat(monthTarget) !== 0 && mtdSales) {
      const achieved = (parseFloat(mtdSales) / parseFloat(monthTarget)) * 100;
      setAchievedPercent(achieved.toFixed(2));
    } else {
      setAchievedPercent("");
    }

    // Closing Cash = Opening Store Cash + Cash Sales A - Cash Deposited + Cash Adjustment
    const opening = parseFloat(openingCash) || 0;
    const cashSales = parseFloat(cashSalesA) || 0;
    const deposited = parseFloat(cashDeposited) || 0;
    const cashAdj = parseFloat(cashAdjustment) || 0;
    const closing = opening + cashSales - deposited + cashAdj;
    setClosingCash(closing.toFixed(2));
  }, [
    cashSalesB,
    eSales,
    eSalesAdjustment, // ✅ Added dependency here
    gvRedemption,
    mtdTarget,
    mtdSales,
    monthTarget,
    openingCash,
    cashSalesA,
    cashDeposited,
    cashAdjustment, // ✅ ensure closing cash updates when adjustment changes
  ]);

  useEffect(() => {
    const e = parseFloat(eSales) || 0;
    const gv = parseFloat(gvRedemption) || 0;
    const cash = parseFloat(cashSalesB) || 0;
    const backend = parseFloat(backendMtdSales) || 0;
    const combined = backend + e + gv + cash; // ✅ include all
    setMtdSales(combined.toFixed(2));

    console.log("📦 Backend MTD:", backend);
    console.log(
      "E:",
      e,
      "GV:",
      gv,
      "CashB:",
      cash,
      "➡️ Final MTD:",
      combined.toFixed(2)
    );
  }, [eSales, gvRedemption]);
  // useEffect(() => {
  //   // Only update Section B when Section A is being edited
  //   if (isEditingSectionA) {
  //     const cashA = parseFloat(cashSalesA) || 0;
  //     const cashB = parseFloat(cashSalesB) || 0;
  //     const e = parseFloat(eSales) || 0;
  //     const gv = parseFloat(gvRedemption) || 0;
  //     const backend = parseFloat(backendMtdSales) || 0;

  //     // Update Cash Sales B based on Cash Sales A logic (example: adding Cash A to B)
  //     const updatedCashB = cashB;
  //     // setCashSalesB(updatedCashB.toFixed(2));

  //     // Update MTD Sales

  //     // Update Total Sales
  //     const total = ogtotalSales - totalSales; //sept 5
  //     console.log(
  //       "og:",
  //       ogtotalSales,
  //       "currenttotalSales:",
  //       totalSales,
  //       "Total:",
  //       total
  //     );
  //     // setTotalSales(total.toFixed(2));

  //     const combined = backend + total;
  //     setMtdSales(combined.toFixed(2));

  //     console.log("🔹 Updated Section B due to Cash Sales A change:");
  //     console.log(
  //       "Cash B:",
  //       cashB,
  //       "MTD:",
  //       combined.toFixed(2),
  //       "Total:",
  //       total.toFixed(2)
  //     );
  //   }
  // }, [cashSalesA, isEditingSectionA]);
  useEffect(() => {
    // skip focus on first dashboard load (last submitted date)
    if (initialLoadRef.current) {
      initialLoadRef.current = false;
      return;
    }

    // ✅ only focus if Section A is completely empty
    if (!openingCash && !cashSalesA && !cashDeposited) {
      requestAnimationFrame(() => {
        if (cashSalesRef.current) {
          cashSalesRef.current.focus();
        }
      });
    }
  }, [selectedDate, openingCash, cashSalesA, cashDeposited]);

  useEffect(() => {
    const opening = parseInt(openingStock) || 0;
    const inwardHO = parseInt(stockInward) || 0;
    const sold = parseInt(saleQty) || 0;
    const outwardStores = parseInt(stockOutward) || 0;
    const adjustment = parseInt(stockAdjustment) || 0; // ✅ new

    const closing = opening + inwardHO - sold - outwardStores + adjustment; // ✅ include adjustment

    setClosingStock(closing.toString());
  }, [
    openingStock,
    stockInward,
    saleQty,
    stockOutward,
    stockAdjustment, // ✅ dependency
  ]);

  useEffect(() => {
    if (!selectedDate) return;

    // Skip auto-focus on the very first load
    if (isFirstLoad) {
      setIsFirstLoad(false);
      return;
    }

    // ✅ Focus only if it's a new date (all fields empty)
    const isSectionAEmpty = !openingCash && !cashSalesA && !cashDeposited;

    if (isSectionAEmpty && cashSalesRef.current) {
      setTimeout(() => cashSalesRef.current.focus(), 0);
    }
  }, [selectedDate, openingCash, cashSalesA, cashDeposited]);

  const handleAllSubmit = async () => {
    try {
      console.log("Submitting A...");
      await handleSectionSubmit("A");

      console.log("Submitting B...");
      await handleSectionSubmit("B");

      console.log("Submitting C...");
      await handleSectionSubmit("C");

      alert("All Sections Submitted Successfully");
    } catch (err) {
      console.log("⛔ Stopped at:", err);
    }
  };

  const handleSectionSubmit = (section) => {
    return new Promise((resolve, reject) => {
      const formattedSelectedDate = selectedDate
        ? new Date(selectedDate).toISOString().slice(0, 10) // "2025-07-15"
        : "";

      setVisibleSection(section); // ✅ Update visible section

      console.log(formattedSelectedDate); // e.g. "15-07-25"

      // Helper function to clean numeric input before sending
      const clean = (val) => {
        if (val === "" || val === null || val === undefined) return null;
        const cleaned = parseFloat(val.toString().replace(/[^0-9.\-]/g, ""));
        return isNaN(cleaned) ? null : cleaned;
      };

      // For Section A
      if (section === "A") {
        if (!openingCash || !cashSalesA || !cashDeposited) {
          alert("Please fill all required fields in Section A.");
          return reject("Missing required A fields");
        }

        // ✅ Check if Section A is already submitted for this date
        const alreadySubmitted = submittedRows.find(
          (row) => row.date === selectedDate && row.data?.sectionA
        );

        if (alreadySubmitted) {
          alert("Section A has already been submitted for this date!");
          return reject("A already submitted");
        }
        const submitSectionA = () => {

          console.log("🔄 Posting Section A data");
          console.log("📅 Date being sent:", selectedDate, cashSalesA);

          fetch(`${API_BASE_URL}/api/insert_eod_data.php`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              section: "A",
              openCashBal: openingCash,
              cashSales: cashSalesA,
              cashDeposit: cashDeposited,
              closeCashBal: closingCash,
              cashAdjustment: cashAdjustment,
              cashAdjustmentRemark: cashAdjustmentRemark,
              selectedDate: selectedDate,
              selectedBank: selectedBank,
              userID,
            }),
          })
            .then((res) => res.json())
            .then((response) => {
              if (response.success) {
                console.log("✅ Section A data inserted successfully.");
                fetchSectionData("A"); // Refresh rawSectionData
                // fetchSectionData("B"); // 🔥 Add this line to sync CashSalesB with latest

                // ✅ turn inputs back to readonly
                setIsEditingSectionA(false);

                // if (selectedDate === "2025-07-01") {
                //   setIsOpeningCashReadOnly(true); // Lock field after submit
                // }

                // 🔒 Special lock rule for Opening Cash
                if (selectedDate === "2026-01-01") {
                  setIsOpeningCashReadOnly(true); // Only lock once 27-08-2025 is submitted
                }
                setIsSectionASubmitted(true);
                checkAllSectionsSubmitted();

                // ✅ Reset button state
                setIsSectionAChanged(false);

                const inserted = response.inserted || {};
                const date = inserted.CreatedAt
                  ? new Date(inserted.CreatedAt)
                    .toLocaleDateString("en-GB")
                    .replaceAll("/", "-")
                  : selectedDate;

                const newSectionAData = {
                  "Opening Store Cash Balance (₹)":
                    inserted.OpenCashBal ?? openingCash,
                  "Cash Sales for the Day (₹)": inserted.CashSales ?? cashSalesA,
                  "Cash Deposited Today (₹)": inserted.CashDeposit ?? cashDeposited,
                  "Closing Cash Balance (₹)": inserted.CloseCashBal ?? closingCash,
                  "Cash Adjustment (₹)": inserted.cashAdjustment ?? cashAdjustment,
                  "Cash Adjustment Remark":
                    inserted.CashAdjustmentRemark ?? cashAdjustmentRemark,
                };

                // ✅ Mark Section A as submitted
                setSubmittedRows((prev) => {
                  const existingRow = prev.find((row) => row.date === date);
                  if (existingRow) {
                    return prev.map((row) =>
                      row.date === date
                        ? {
                          ...row,
                          data: {
                            ...row.data,
                            ...newSectionAData,
                            sectionA: true,
                          },
                        }
                        : row
                    );
                  } else {
                    return [
                      ...prev,
                      { date, data: { ...newSectionAData, sectionA: true } },
                    ];
                  }
                });

                handleSectionClick("A");
                // alert("Section A: Sales Cash Balance data submitted");
                // if (eSalesRef.current) eSalesRef.current.focus();
                resolve();            // ✅ <-- ADD THIS HERE
              } else {
                if (response.message?.includes("already")) {
                  alert(response.message); // 👉 "Section A has already been submitted for this date!"
                } else {
                  alert("Failed to save Section A data.");
                  reject("Section A insert failed");  // ❌ <-- ADD THIS HERE
                }
                console.error("Insert failed:", response.message || response.error);
              }
            })
            .catch((err) => {
              console.error("Error:", err);
              alert("Error occurred while saving Section A.");
              reject("Section A server error");     // ❌ <-- ADD THIS HERE
            });
        };
        if (parseFloat(cashSalesA) === 0) {
          setIsShowingAlert(true);
          Swal.fire({
            title: "Cash Sales is 0.00",
            text: "Submit Section A with zero cash sales?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
          }).then((result) => {
            if (!result.isConfirmed) {
              setIsShowingAlert(false);
              // if (cashSalesRef?.current) cashSalesRef.current.focus();
              setTimeout(() => {
                cashSalesRef?.current?.focus();   // ✅ prevents jump to Final Submit
              }, 50);
              return;
            }
            setIsShowingAlert(false);
            submitSectionA(); // ✅ Continue submission
          });
          return; // ✅ Stop normal flow (submit happens in Swal block)
        }
        submitSectionA();
      }

      // =======================
      // ✅ Section B Submission
      // =======================
      if (section === "B") {
        if (clean(cashSalesB) === null || clean(eSales) === null) {
          alert("Please fill all required numeric fields in Section B.");
          return reject("Missing required B fields");
        }

        console.log("🔄 Posting Section B data");
        const submitSectionB = () => {

          fetch(`${API_BASE_URL}/api/insert_eod_data.php`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              section: "B",
              selectedDate: selectedDate,
              cashSalesB: clean(cashSalesB),
              eSales: clean(eSales), // original E-Sales
              eSalesAdjustment: parseFloat(eSalesAdjustment) || 0, // separate adjustment
              gvRedemption: clean(gvRedemption),
              dayTarget: clean(dayTarget),
              totalSales: clean(totalSales),
              mtdTarget: clean(mtdTarget),
              mtdSales: clean(mtdSales),
              backlog: clean(backlog),
              monthTarget: clean(monthTarget),
              achievedPercent: clean(achievedPercent),
              totalBills: clean(totalBills),
              manualBillNo: manualBillNo || null,
              walkins: clean(walkins),
              headcount: clean(headcount),
              userID,
            }),
          })
            .then((res) => res.json())
            .then((response) => {
              if (response.success) {
                console.log("✅ Section B data inserted/updated successfully.");
                const inserted = response.inserted || {};
                const date = formattedSelectedDate;

                const formatGridValue = (val) => {
                  if (val === null || val === undefined) return "-";
                  if (val === 0 || val === "0" || val === "0.00" || val === ".00")
                    return "-";
                  return val;
                };

                const newSectionBData = {
                  "Cash Sales (₹)": formatGridValue(
                    inserted.CashSalesB ?? cashSalesB
                  ),
                  "E-Sales (₹)": formatGridValue(inserted.ESales ?? eSales),
                  "E-Sales Adjustment (₹)": formatGridValue(
                    parseFloat(eSalesAdjustment) || 0
                  ),
                  "GV Redemption (₹)": formatGridValue(inserted.GV ?? gvRedemption),
                  "Day Target (₹)": formatGridValue(
                    inserted.DayTarget ?? dayTarget
                  ),
                  "Total Sales (₹)": formatGridValue(
                    inserted.TotalSales ?? totalSales
                  ),
                  "MTD Target (₹)": formatGridValue(
                    inserted.MTDTarget ?? mtdTarget
                  ),
                  "MTD Sales (₹)": formatGridValue(inserted.MTDSales ?? mtdSales),
                  "Backlog (₹)": formatGridValue(inserted.Backlog ?? backlog),
                  "Month Target (₹)": formatGridValue(
                    inserted.MonthTarget ?? monthTarget
                  ),
                  "Achieved %": formatGridValue(
                    inserted.Achieved ?? achievedPercent
                  ),
                  "Total Bills": formatGridValue(inserted.TotalBills ?? totalSales),
                  "Manual Bill No": formatGridValue(
                    inserted.ManualBillNo ?? manualBillNo
                  ),
                  Walkins: formatGridValue(inserted.WalkIns ?? walkins),
                  Headcount: formatGridValue(inserted.HeadCount ?? headcount),
                };

                setSubmittedRows((prev) => {
                  const existingRow = prev.find((row) => row.date === date);
                  const others = prev.filter((row) => row.date !== date);

                  const mergedRow = {
                    date,
                    data: {
                      ...(existingRow?.data || {}),
                      ...newSectionBData,
                      sectionB: true,
                    },
                  };
                  return [...others, mergedRow];
                });

                // ✅ After submit, make Section B read-only
                setIsEditingSectionB(false);
                setIsSectionBChanged(false);
                setIsSectionBSubmitted(true);
                checkAllSectionsSubmitted();

                // Optional refresh
                handleSectionClick("B");
                // alert("Section B: Sale Summary data submitted");

                // ✅ Move focus to “Stock Inward from HO / Other Stores”
                // setTimeout(() => {
                //   stockInwardRef?.current?.focus();
                // }, 100);
                resolve();
              } else {
                alert(response.message || "Failed to save Section B data.");
                reject("Section B insert failed");  // ❌ <-- ADD THIS HERE
                console.error("Insert failed:", response.message || response.error);
              }
            })
            .catch((err) => {
              console.error("Error:", err);
              alert("Error occurred while saving Section B.");
              reject("Section B server error");     // ❌ <-- ADD THIS HERE
            });
        };
        // ✅ If E-Sales is 0, ask confirmation
        if (parseFloat(eSales) === 0) {
          Swal.fire({
            title: "E-Sales is 0.00",
            text: "Submit Section B with zero E-Sales?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
          }).then((result) => {
            if (!result.isConfirmed) {
              if (eSalesRef?.current) eSalesRef.current.focus();
              return;
            }
            submitSectionB(); // ✅ trigger B submit manually on Yes
          });
          return; // ✅ stop normal flow
        }
        submitSectionB();

      }

      // =======================
      // ✅ Section C Submission
      // =======================
      if (section === "C") {
        const cleanedOpeningStock = clean(openingStock);
        // const cleanedStockInwHO = clean(stockInward);
        // const cleanedStockInwStore = clean(stockInwardStores);
        // const cleanedStockOutwStore = clean(stockOutward);
        const cleanedSaleQty = clean(saleQty);
        const cleanedStockAdjustment = clean(stockAdjustment); // ✅ NEW
        const cleanedClosingStock = clean(closingStock);
        const submitSectionC = () => {
          console.log("🔄 Posting Section C data");

          fetch(`${API_BASE_URL}/api/insert_eod_data.php`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              section: "C",
              selectedDate: formattedSelectedDate,
              openingStock: cleanedOpeningStock,
              // stockInwHO: stockInwHOValue,
              // stockInwStore: stockInwStoreValue,
              // stockOutwHO: stockOutwHOValue,
              // stockOutwStore: stockOutwStoreValue,
              saleQty: cleanedSaleQty,
              stockAdjustment: cleanedStockAdjustment, // ✅ NEW
              closingStock: cleanedClosingStock,
              userID,
            }),
          })
            .then((res) => res.json())
            .then((response) => {
              if (response.success) {
                console.log("✅ Section C data inserted/updated successfully.");
                const inserted = response.inserted || {};
                const date = formattedSelectedDate;

                // ✅ Utility function to display "-" for 0 values
                const displayValue = (val) =>
                  val === 0 || val === "0" ? "-" : val;

                // ✅ Apply displayValue *before* updating submittedRows
                const sectionCData = {
                  "Opening Stock": displayValue(
                    inserted.OpeningStock ?? openingStock
                  ),
                  "Stock Inward from HO": displayValue(
                    inserted.StockInwHO ?? stockInward
                  ),
                  "Stock Inward from Other Stores": displayValue(
                    inserted.StockInwStore ?? stockInward
                  ),
                  "Stock Outward to HO": displayValue(
                    inserted.StockOutwHO ?? stockOutward
                  ), // ✅ ADDED
                  "Stock Outward to Other Stores": displayValue(
                    inserted.StockOutwStore ?? stockOutward
                  ),
                  // "Stock Inward from Other Stores": displayValue(
                  //   inserted.StockInwStore ?? stockInwardStores
                  // ),
                  // "Stock Outward to Other Stores": displayValue(
                  //   inserted.StockOutwStore ?? stockOutward
                  // ),
                  "Sale Quantity": displayValue(inserted.SaleQty ?? saleQty),
                  "Closing Stock": displayValue(
                    inserted.ClosingStock ?? closingStock
                  ),
                  "Stock Adjustment": displayValue(
                    inserted.StockAdjustment ?? stockAdjustment
                  ), // ✅ NEW
                };

                // ✅ Merge with existing row (A + B + C together)
                setSubmittedRows((prev) => {
                  const existingRow = prev.find((row) => row.date === date);
                  const others = prev.filter((row) => row.date !== date);

                  const mergedRow = {
                    date,
                    data: {
                      ...(existingRow?.data || {}),
                      ...sectionCData,
                    },
                  };

                  return [...others, mergedRow];
                });

                // ✅ Special case: lock Opening Stock only on July 1
                if (selectedDate === "2026-01-01") {
                  setIsOpeningStockReadOnly(true); // 🔒 Lock Opening Stock on first date
                }

                // ✅ After submit, make Section C read-only
                setIsEditingSectionC(false);
                setIsSectionCChanged(false); // ✅ reset buttons
                setIsSectionCSubmitted(true); // ✅ mark submitted
                checkAllSectionsSubmitted();

                // alert("Section C: Quantitative Information data submitted");

                // Optional: refresh backend data if needed
                handleSectionClick("C");
                resolve();
              } else {
                alert(response.message || "Failed to save Section C data.");
                reject("Section C insert failed");  // ❌ <-- ADD THIS HERE
                console.error("Insert failed:", response.message || response.error);
              }
            })
            .catch((err) => {
              console.error("Error:", err);
              alert("Error occurred while saving Section C.");
              reject("Section C Server Error");
            });
        }
        if (parseFloat(saleQty) === 0 || saleQty === "") {
          const cs = parseFloat(cashSalesA) || 0;
          const es = parseFloat(eSales) || 0;

          // If either Cash Sales or E-Sales is already recorded → show ONLY OK alert
          if (cs > 0 || es > 0) {
            let recorded =
              cs > 0 && es > 0
                ? "Cash Sales and E-Sales are already recorded."
                : cs > 0
                  ? "Cash Sales is already recorded."
                  : "E-Sales is already recorded.";

            Swal.fire({
              title: "Sale Qty is 0",
              text: `${recorded} So Sale Qty cannot be 0.`,
              icon: "warning",
              confirmButtonText: "OK",
              focusConfirm: true,
            }).then(() => {
              setTimeout(() => saleQtyRef?.current?.focus(), 0);
            });
            return; // Stop here
          }

          // If both cs & es are 0 → allow saleQty = 0 (no alert)
          submitSectionC(); // Continue process
          return;
        }
        // ✅ NEW CHECK: saleQty > 0 but both cs & es are 0 → not allowed
        const cs = parseFloat(cashSalesA) || 0;
        const es = parseFloat(eSales) || 0;
        if (parseFloat(saleQty) > 0 && cs === 0 && es === 0) {
          Swal.fire({
            title: "Invalid Sale Quantity",
            text: "Both Cash Sales and E-Sales are 0. You cannot enter a Sale Qty greater than 0.",
            icon: "error",
            confirmButtonText: "OK",
            focusConfirm: true,
          }).then(() => {
            setTimeout(() => saleQtyRef?.current?.focus(), 0);
          });
          return;
        }
        submitSectionC();
      }
    });
  };

  const checkAllSectionsSubmitted = () => {
    if (isSectionASubmitted && isSectionBSubmitted && isSectionCSubmitted) {
      setCanEditNextDate(true);
      console.log("✅ All 3 sections submitted. Next date allowed.");
    } else {
      setCanEditNextDate(false);
      console.log("❌ Not all sections submitted yet. Next date locked.");
    }
  };

  // Amount fields (2 decimals)
  const amountFields = [
    "cashSalesA",
    "cashDeposited",
    "cashAdjustment",
    "eSales",
    "eSalesAdjustment",
    "gvRedemption",
    "backlog",
  ];

  // Integer/count fields (default 0)
  const integerFields = [
    "totalBills",
    "manualBillNo",
    "walkins",
    "headcount",
    "stockInward",
    "stockOutward",
    "saleQty",
    "stockAdjustment",
  ];

  const renderInput = (
    value,
    setter,
    readOnly = false,
    integerOnly = false,
    name = "",
    inputRef = null,
    section = "",
    onChangeExtra = null,
    extraProps = {}
  ) => {
    const highlightedFields = [...amountFields, ...integerFields];

    const shouldHighlight = (fieldName, readOnly) => {
      if (fieldName === "cashAdjustment") return true; // always highlight
      return readOnly && highlightedFields.includes(fieldName);
    };

    const handleBlur = (e) => {
      if (!readOnly) {
        const trimmedValue = value?.toString().trim();

        setTimeout(() => {
          // ✅ delay to avoid Enter-triggered blur
          // Amount fields → 2 decimals, default 0.00
          if (amountFields.includes(name)) {
            setter(
              !trimmedValue || isNaN(trimmedValue)
                ? "0.00"
                : parseFloat(trimmedValue).toFixed(2)
            );
          }
          // Integer/count fields → default 0
          else if (integerFields.includes(name)) {
            setter(
              !trimmedValue || isNaN(trimmedValue)
                ? "0"
                : String(parseInt(trimmedValue, 10))
            );
          }
        }, 50); // 50ms is enough for Enter focus movement
      }

      if (extraProps.onBlur) extraProps.onBlur(e);
    };

    return (
      <input
        type="text"
        name={name}
        ref={inputRef}
        value={value}
        readOnly={readOnly}
        tabIndex={readOnly ? -1 : 0}
        className={[
          "form-control",
          shouldHighlight(name, readOnly) ? "readonly-highlight" : "",
        ].join(" ")}
        style={{
          fontWeight: "bold",
          fontSize: "16px",
          textAlign: "right",
          padding: "6px 10px",
          pointerEvents: readOnly ? "none" : "auto",
        }}
        onChange={(e) => {
          let newValue = e.target.value;

          // ✅ Allow + and - only for specific adjustment fields
          if (
            ["cashAdjustment", "eSalesAdjustment", "stockAdjustment"].includes(
              name
            )
          ) {
            newValue = newValue.replace(/[^0-9+-]/g, ""); // allow digits, +, -
          } else {
            newValue = newValue.replace(/[^0-9]/g, ""); // allow digits only
          }

          setter(newValue);

          if (section === "A") setIsSectionAChanged(true);
          if (section === "B") setIsSectionBChanged(true);
          if (section === "C") setIsSectionCChanged(true);

          if (onChangeExtra) onChangeExtra(e);
        }}
        onKeyDown={(e) => {
          let skipDefaultFocus = false;

          if (onChangeExtra) {
            onChangeExtra({
              ...e,
              preventDefault: () => {
                e.preventDefault();
                skipDefaultFocus = true;
              },
            });
          }

          if (e.key === "Enter" && !readOnly && !skipDefaultFocus) {
            e.preventDefault();
            setter(value); // keep current value
            // move focus to next input
            const form = e.target.form;
            const elements = Array.from(form.elements);
            const currentIndex = elements.indexOf(e.target);
            for (let i = currentIndex + 1; i < elements.length; i++) {
              const nextInput = elements[i];
              if (
                nextInput.tagName === "INPUT" &&
                !nextInput.readOnly &&
                !nextInput.disabled &&
                nextInput.type !== "hidden"
              ) {
                nextInput.focus();
                break;
              }
            }
          }
        }}
        onBlur={handleBlur}
        {...extraProps}
      />
    );
  };

  const clearSectionA = () => {
    // if (isReadOnly) return; // 🔒 Don't clear if read-only
    if (isStoredDataAvailable("A") && !isEditingSectionA) return; // 🔒 respect stored lock
    setCashSalesA("");
    setCashDeposited("");
    setSelectedBank("");
    setCashAdjustment("");
    setIsSectionAChanged(true); // ✅ keep buttons enabled after clearing
  };

  const clearSectionB = () => {
    if (isStoredDataAvailable("B") && !isEditingSectionB) return; // 🔒 respect stored lock

    setESales("");
    setESalesAdjustment("");
    setGvRedemption("");
    setTotalBills("");
    setManualBillNo("");
    setWalkins("");
    setHeadcount("");

    setIsSectionBChanged(false); // reset after clearing
  };

  const clearSectionC = () => {
    if (isStoredDataAvailable("C") && !isEditingSectionC) return; // 🔒 respect stored lock

    setStockInward("");
    setStockOutward("");
    setStockAdjustment("");
    setSaleQty("");

    setIsSectionCChanged(false); // reset after clearing
  };
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = String(d.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  };
  const valueStyle = { color: "#0000FF", fontSize: "20px", fontWeight: "bold" };
  const isAllSubmitted =
    isSectionASubmitted && isSectionBSubmitted && isSectionCSubmitted;

  return (
    <>
      <div
        style={{
          position: "absolute",
          top: "10px",
          left: "20px",
          display: "flex",
          alignItems: "center",
          gap: "12px", // spacing between logo and label
          zIndex: 1000,
        }}
      >
        <img
          src="./prisma-logo.png"
          alt="Prisma Logo"
          style={{
            width: "120px",
            height: "40px",
          }}
        />
        <span
          style={{
            fontWeight: "bold",
            fontSize: "20px",
            color: "#050505ff",
            height: "25px",
            backgroundColor: "#add4c9ff",
            padding: "6px 10px",
            border: "1px solid black",
            borderRadius: "6px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          }}
        >
          REOD
        </span>
      </div>

      <div className="dashboard">
        <h2
          style={{
            marginTop: "-15px",
            textAlign: "center",
            marginBottom: "5px",
            color: "rgba(154, 117, 78, 1)",
          }}
        >
          RETAIL STORE END OF THE DAY REPORT
        </h2>

        {/* <div
          style={{
            position: "absolute",
            top: "10px",
            right: "150px",
            // fontWeight: "600",
            fontSize: "20px",
            backgroundColor: "#add4c9ff",
            padding: "6px 12px",
            borderRadius: "6px",
            boxShadow: "0 0 4px rgba(0,0,0,0.1)",
            color: "rgba(7, 7, 7, 1)",
            border: "1px solid black",
          }}
        >
          Store Name: {storeName}
        </div> */}
        <div
          style={{
            position: "absolute",
            top: "10px",
            right: "150px",
            fontSize: "20px",
            backgroundColor: "#add4c9ff",
            padding: "6px 12px",
            borderRadius: "6px",
            boxShadow: "0 0 4px rgba(0,0,0,0.1)",
            color: "rgba(7, 7, 7, 1)",
            border: "1px solid black",
          }}
        >
          Store Name:{" "}
          {isAdmin === 1 ? (
            <>
              {/* Autocomplete input */}
              <input
                type="text"
                list="storeOptions"
                value={selectedStore}
                onChange={(e) => setSelectedStore(e.target.value)}
                style={{
                  padding: "4px 8px",
                  fontSize: "16px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  minWidth: `${Math.max(220, selectedStore.length * 12)}px`, // auto width
                }}
              />
              <datalist id="storeOptions">
                {Array.isArray(stores) &&
                  stores.map((s, idx) => (
                    <option key={idx} value={s.StoreName} />
                  ))}
              </datalist>
            </>
          ) : (
            <span>{storeName}</span>
          )}
        </div>

        <Tippy content="Logout" placement="bottom">
          <button
            onClick={handleLogout}
            style={{
              position: "absolute", // Or flex-end depending on layout
              top: "6px",
              right: "90px",
              height: "50px",
              fontWeight: "bold",
              fontSize: "16px",
              padding: "8px 12px",
              backgroundColor: "transparent",
              outline: "none",
              color: "#e74c3c",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            <FiPower size={25} />
          </button>
        </Tippy>

        {/* ✅ Date + Buttons in one row */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            marginBottom: "5px",
          }}
        >
          {/* Date Picker with Previous & Next-Day Arrows */}
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              borderRadius: "5px",
              overflow: "hidden",
              border: "1px solid #ccc",
            }}
          >
            {/* Previous Day Button */}
            <button
              type="button"
              onClick={() => {
                const current = new Date(selectedDate);
                current.setDate(current.getDate() - 1); // decrement by 1 day
                const prevDate = current.toISOString().split("T")[0]; // format YYYY-MM-DD
                setSelectedDate(prevDate);
              }}
              onMouseEnter={() => setHoverPrevDate(true)}
              onMouseLeave={() => setHoverPrevDate(false)}
              style={{
                padding: "5px 10px",
                fontSize: "16px",
                fontWeight: "bold",
                border: "none",
                backgroundColor: hoverPrevDate ? "#27ba64ff" : "#eee", // ✅ hover green
                cursor: "pointer",
                transition: "background-color 0.2s ease",
              }}
            >
              &lt; {/* Previous day arrow */}
            </button>

            {/* Date Input */}
            <input
              type="date"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              ref={dateInputRef}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  if (cashSalesRef.current) {
                    cashSalesRef.current.focus();
                  }
                }
              }}
              style={{
                padding: "5px 10px",
                fontSize: "16px",
                fontWeight: "bold",
                border: "none",
                outline: "none",
                width: "120px",
                fontFamily: "Trebuchet MS",
              }}
            />

            {/* Next Day Button */}
            <button
              type="button"
              onClick={() => {
                const current = new Date(selectedDate);
                current.setDate(current.getDate() + 1); // increment by 1 day
                const nextDate = current.toISOString().split("T")[0]; // format YYYY-MM-DD

                // 🔑 clear Section A fields before fetching
                setOpeningCash("");
                setCashSalesA("");
                setCashDeposited("");
                setSelectedBank("");
                setSelectedDate(nextDate);
              }}
              onMouseEnter={() => setHoverNextDate(true)}
              onMouseLeave={() => setHoverNextDate(false)}
              style={{
                padding: "5px 10px",
                fontSize: "16px",
                fontWeight: "bold",
                border: "none",
                backgroundColor: hoverNextDate ? "#27ba64ff" : "#eee", // ✅ hover green
                cursor: "pointer",
                transition: "background-color 0.2s ease",
              }}
            >
              &gt; {/* Next day arrow */}
            </button>
          </div>

          {/* PDF Button */}
          <Tippy content="Export as PDF for this date" placement="top">
            <button
              onClick={handleExportPDF}
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
              style={{
                padding: "5px 10px",
                fontSize: "16px",
                backgroundColor: hover ? "#27ba64ff" : "#948f8fff",
                color: "#fff",
                border: "1px solid #565b5f",
                borderRadius: "5px",
                cursor: "pointer",
                transition: "background-color 0.2s ease",
                fontFamily: "Trebuchet MS",
              }}
            >
              PDF
            </button>
          </Tippy>

          {/* Excel Button */}
          <Tippy content="Export as Excel for this date" placement="top">
            <button
              onClick={handleExportExcel}
              onMouseEnter={() => setHoverExcel(true)}
              onMouseLeave={() => setHoverExcel(false)}
              style={{
                padding: "5px 10px",
                fontSize: "16px",
                backgroundColor: hoverExcel ? "#27ba64ff" : "#948f8fff",
                transition: "background-color 0.2s ease",
                color: "#fff",
                border: "1px solid #565b5f",
                borderRadius: "5px",
                cursor: "pointer",
                fontFamily: "Trebuchet MS",
              }}
            >
              Excel
            </button>
          </Tippy>
        </div>

        <form className="dashboard-form">
          {/* SECTION CONTAINER WRAPPER */}
          <div className="dashboard-sections">
            {/* A. CASH BALANCE */}
            <div className="section-container section-a">
              <h3
                style={{
                  marginTop: "1px",
                  marginBottom: "20px",
                  color: "black", // Default plain black
                  cursor: "pointer", // Show hand on hover
                }}
                onMouseOver={(e) => {
                  e.target.style.color = "#1E90FF"; // Hover blue
                  e.target.style.textDecoration = "underline";
                }}
                onMouseOut={(e) => {
                  e.target.style.color = "black"; // Back to black
                  e.target.style.textDecoration = "none";
                }}
                onClick={() => handleSectionClick("A")}
              >
                A. SALES CASH BALANCE
              </h3>

              <div className="form-row">
                <div className="form-group opening-store-cash-balance">
                  <label>Opening Store Cash Balance (₹)</label>
                  {renderInput(
                    openingCash,
                    (val) => setOpeningCash(val),
                    selectedDate !== "2026-01-01" || isOpeningCashReadOnly // ✅ Read-only if not 01-07-2025 OR after submit
                  )}
                </div>

                <div className="form-row">
                  <div className="form-group cash-sales-for-the-day">
                    <label>Cash Sales (₹)</label>
                    {renderInput(
                      cashSalesA,
                      setCashSalesA,
                      (isSectionASubmitted && isSectionBSubmitted && isSectionCSubmitted) && !isShowingAlert,//false,  isStoredDataAvailable("A") && !isEditingSectionA,
                      false,
                      "cashSalesA",
                      cashSalesRef,
                      "A"
                    )}
                  </div>

                  <div className="form-group cash-deposited-today" style={{ display: "flex", gap: "10px" }}>
                    <label>Cash Deposited (₹)</label>
                    {/* Bank Dropdown */}

                    {renderInput(
                      cashDeposited,
                      setCashDeposited,
                      isSectionASubmitted && isSectionBSubmitted && isSectionCSubmitted,//false, isStoredDataAvailable("A") && !isEditingSectionA,
                      false,
                      "cashDeposited",
                      cashDepositedRef,
                      "A"
                    )}
                    {/* Show Bank Dropdown only if cashDeposited > 0 */}
                    {Number(cashDeposited) > 0 && (
                      <select
                        className="form-control"
                        style={{
                          padding: "8px 12px",
                          borderRadius: "6px",
                          border: "1px solid #ccc",
                          fontSize: "14px",
                          width: "85px",
                          backgroundColor: "#fff",
                        }}
                        value={selectedBank}
                        onChange={(e) => setSelectedBank(e.target.value)}
                        disabled={isSectionASubmitted && isSectionBSubmitted && isSectionCSubmitted}
                      >
                        {/* Only show empty option if no bank is selected */}
                        {/* {selectedBank === "" && (
                          <option value="">--</option>
                        )} */}
                        {bankData.map((bank) => (
                          <option key={bank.bankid} value={bank.banknameshort}>
                            {bank.banknameshort}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>
                </div>

                {/* CASH ADJUSTMENT FIELD */}
                <div className="form-group cash-adjustment">
                  <label>Cash Adjustment (₹)</label>
                  {renderInput(
                    cashAdjustment,
                    setCashAdjustment,
                    isSectionASubmitted && isSectionBSubmitted && isSectionCSubmitted, //false, isStoredDataAvailable("A") && !isEditingSectionA,
                    false,
                    "cashAdjustment",
                    cashAdjustmentRef,
                    "A",
                    (e) => {
                      if (e.key === "Enter") {
                        e.preventDefault(); // prevent default
                        const value = parseFloat(cashAdjustment);

                        // sectionASubmitRef.current.focus();
                        eSalesRef.current.focus();
                        // }
                      }
                    }
                  )}
                </div>

                <div className="form-group closing-cash-balance">
                  <label>Closing Cash Balance (₹)</label>
                  {renderInput(closingCash, () => { }, true)}
                </div>
                {closingCashWarning && (
                  <p
                    style={{
                      color: "red",
                      fontWeight: "bold",
                      marginTop: "-10px",
                      marginBottom: "10px",
                      marginLeft: "5px",
                    }}
                  >
                    {closingCashWarning}
                  </p>
                )}
              </div>

              {/* Section A Action Buttons */}
              <div
                className="section-actions"
                style={{ textAlign: "right", marginTop: "10px" }}
              >
                {/* Submit Button */}
                {/* <button
                  type="button"
                  className="submit-button"
                  id="submit-button-section-a"
                  onClick={() => handleSectionSubmit("A")}
                  ref={sectionASubmitRef}
                  style={{
                    backgroundColor:
                      !isEditingSectionA && isSectionAChanged
                        ? "green"
                        : "grey",
                    color: "white",
                    padding: "8px 16px",
                    border: "none",
                    borderRadius: "5px",
                    cursor:
                      !isEditingSectionA && isSectionAChanged
                        ? "pointer"
                        : "not-allowed",
                    marginRight: "8px",
                    // pointerEvents:
                    //   isEditingSectionA && isSectionAChanged ? "auto" : "none", // ✅ block clicks visually
                  }}
                >
                  Submit
                </button> */}

                {/* Clear Button */}
                {/* Clear Button */}
                <button
                  type="button"
                  className="clear-button skip-focus"
                  onClick={() => {
                    clearSectionA();
                  }}
                  // disabled={
                  //   (isStoredDataAvailable("A") && !isEditingSectionA) ||
                  //   !isSectionAChanged
                  // }
                  style={{
                    backgroundColor:
                      (!isStoredDataAvailable("A") || isEditingSectionA) &&
                        isSectionAChanged
                        ? "green"
                        : "grey",
                    color: "white",
                    padding: "8px 16px",
                    border: "none",
                    borderRadius: "5px",
                    cursor:
                      (!isStoredDataAvailable("A") || isEditingSectionA) &&
                        isSectionAChanged
                        ? "pointer"
                        : "not-allowed",
                    marginRight: "8px",
                  }}
                >
                  Clear
                </button>

                {/* Edit Button */}
                {/* <button
                  type="button"
                  className="edit-button"
                  id="edit-button-section-a"
                  onClick={() => handleSectionEdit("A")}
                  disabled={!sectionAData || isEditingSectionA} // disable if no data (new date) OR already editing
                  style={{
                    backgroundColor:
                      !sectionAData || isEditingSectionA ? "grey" : "green", // grey when new date OR editing
                      color: "white",
                      padding: "8px 16px",
                      border: "none",
                      borderRadius: "5px",
                      cursor:
                      !sectionAData || isEditingSectionA
                      ? "not-allowed"
                      : "pointer", // pointer only when data exists & not editing
                      marginRight: "8px",
                      }}
                      >
                      Edit
                      </button> */}

                {/* Remark Button */}
                <button
                  type="button"
                  className="remark-button"
                  onClick={() =>
                    openRemarkModal("A", "Remarks - Sales Cash Balance")
                  }
                  disabled={false} // ✅ always enabled
                  style={{
                    backgroundColor: "green",
                    color: "white",
                    padding: "8px 16px",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                    fontFamily: "Trebuchet MS",
                  }}
                >
                  Remark
                </button>
              </div>

              {/* Remark Modal for Section A */}
              {isRemarkModalOpenA && (
                <RemarkModal
                  isOpen={isRemarkModalOpenA}
                  section="A"
                  modalTitle={remarkModalTitleA} // ✅ dynamic title passed
                  onClose={() => setIsRemarkModalOpenA(false)}
                  userID={userID}
                  selectedDate={selectedDate}
                />
              )}
            </div>

            {/* B. SALE SUMMARY */}
            <div className="section-container ">
              <h3
                style={{
                  marginTop: "1px",
                  marginBottom: "1px",
                  color: "black",
                  cursor: "pointer",
                }}
                onMouseOver={(e) => {
                  e.target.style.color = "#1E90FF"; // Hover color
                  e.target.style.textDecoration = "underline";
                }}
                onMouseOut={(e) => {
                  e.target.style.color = "black"; // Reset color
                  e.target.style.textDecoration = "none";
                }}
                onClick={() => {
                  setIsMonthTarget(false);
                  handleSectionClick("B");
                }}
              >
                B. SALE SUMMARY
              </h3>

              {/* Grid only for inputs */}
              <div className="section-b-grid">
                <div className="form-group cash-sales-b">
                  <label>Cash Sales(₹)</label>
                  {renderInput(cashSalesB, setCashSalesB, true)}{" "}
                  {/* ✅ readOnly enabled */}
                </div>
                <div className="form-group e-sales">
                  <label>E-Sales(₹)</label>
                  {renderInput(
                    eSales,
                    setESales, // always allow state update
                    isSectionASubmitted && isSectionBSubmitted && isSectionCSubmitted,//false, isStoredDataAvailable("B") && !isEditingSectionB, // lock only if stored and not editing
                    false, // integerOnly (set to true if needed)
                    "eSales", // name for highlighting
                    eSalesRef, // 🔹 pass ref here
                    "B" // 🟢 section flag instead of callback
                  )}
                </div>

                {/* E-Sales Adjustment */}
                <div className="form-group e-sales-adjustment">
                  <label>E-Sales Adj.(₹)</label>
                  {renderInput(
                    eSalesAdjustment,
                    setESalesAdjustment, // state setter
                    isSectionASubmitted && isSectionBSubmitted && isSectionCSubmitted,//false, isStoredDataAvailable("B") && !isEditingSectionB, // lock if stored & not editing
                    false, // integerOnly
                    "eSalesAdjustment", // name for highlighting
                    eSalesAdjustmentRef, // optional ref
                    "B", // section flag
                    (e) => {
                      if (e.key === "Enter" && nextFieldRef?.current) {
                        nextFieldRef.current.focus();
                      }
                    }
                    // {
                    //   onBlur: () => {
                    //     const value = parseFloat(eSalesAdjustment);
                    //     if (!isNaN(value) && value !== 0) {
                    //       // ✅ open Section B remark modal for any non-zero value
                    //       openRemarkModal("B", "Reason for E-Sales Adjustment");
                    //     }
                    //   },
                    // }
                  )}
                </div>

                <div className="form-group gv-redemption">
                  <label>GV Redem. (₹)</label>
                  {renderInput(
                    gvRedemption,
                    setGvRedemption, // always allow updates
                    isSectionASubmitted && isSectionBSubmitted && isSectionCSubmitted, // isStoredDataAvailable("B") && !isEditingSectionB, // readOnly only if stored and not editing
                    false, // integerOnly (change to true if only integers allowed)
                    "gvRedemption", // name used in highlight logic
                    null, // inputRef (pass null if not used)
                    "B" // 🟢 section flag
                  )}
                </div>

                <div className="form-group day-target">
                  <label>Day Target (₹)</label>
                  {renderInput(dayTarget, setDayTarget, true)}
                </div>
                <div className="form-group total-sales">
                  <label>Total Sales (₹)</label>
                  <div className="total-sales-inputs">
                    {renderInput(totalSales, () => { }, true)}
                    <div className="input-with-percent">
                      {renderInput(
                        dayAchievedPercent,
                        setDayAchievedPercent,
                        true
                      )}
                      <span
                        className="percent-symbol"
                        style={{ fontWeight: "bolder" }}
                      >
                        {" "}
                        %
                      </span>
                    </div>
                  </div>
                </div>

                <div className="form-group mtd-row">
                  <div className="mtd-sales-group">
                    <label>MTD Sale (₹)</label>
                    {renderInput(mtdSales, setMtdSales, true)}
                    <div className="input-with-percent">
                      {renderInput(
                        mtdAchievedPercent,
                        setMtdAchievedPercent,
                        true
                      )}
                      <span
                        className="percent-symbol"
                        style={{ fontWeight: "bolder" }}
                      >
                        %
                      </span>
                    </div>
                  </div>

                  <div className="month-target-group">
                    <label>Month Target (₹)</label>
                    {renderInput(monthTarget, setMonthTarget, true)}
                    <div className="input-with-percent">
                      {renderInput(achievedPercent, setAchievedPercent, true)}
                      <span className="percent-symbol">%</span>
                    </div>
                  </div>
                </div>
                <div className="form-group mtd-target">
                  <label>MTD Target (₹)</label>
                  {renderInput(mtdTarget, setMtdTarget, true)}
                </div>

                <div
                  className={`form-group backlog ${parseFloat(backlog) < 0 ? "negative" : "positive"
                    }`}
                >
                  <label style={{ whiteSpace: "nowrap", fontSize: "1rem" }}>MTD Short/Excess (₹)</label>
                  {renderInput(backlog, () => { }, { readOnly: true })}
                </div>

                <div className="form-group total-bills">
                  <label>Total Bills Raised (Ginesys)</label>
                  {renderInput(
                    totalBills,
                    setTotalBills, // always allow updates
                    isSectionASubmitted && isSectionBSubmitted && isSectionCSubmitted, // isStoredDataAvailable("B") && !isEditingSectionB, // readOnly only if stored and not editing
                    true, // integerOnly = true
                    "totalBills", // name
                    null, // inputRef, if not using ref
                    "B"
                  )}
                </div>

                <div className="form-group manual-bill">
                  <label>Manual Bill No</label>
                  {renderInput(
                    manualBillNo,
                    setManualBillNo, // always allow updates
                    isSectionASubmitted && isSectionBSubmitted && isSectionCSubmitted, // isStoredDataAvailable("B") && !isEditingSectionB, // lock only if stored & not editing
                    true, // integerOnly = true
                    "manualBillNo", // ✅ field name
                    null, // ✅ no ref needed here
                    "B"
                  )}
                </div>

                <div className="form-group walkins">
                  <label>Walk Ins</label>
                  {renderInput(
                    walkins,
                    setWalkins, // always allow updates
                    isSectionASubmitted && isSectionBSubmitted && isSectionCSubmitted,// isStoredDataAvailable("B") && !isEditingSectionB, // lock only if stored & not editing
                    true, // integerOnly
                    "walkins", // ✅ field name for highlighting
                    null, // ✅ inputRef if needed, otherwise null
                    "B"
                  )}
                </div>

                <div className="form-group headcount">
                  <label>Head Count</label>
                  {renderInput(
                    headcount,
                    setHeadcount, // always allow updates
                    isSectionASubmitted && isSectionBSubmitted && isSectionCSubmitted,// isStoredDataAvailable("B") && !isEditingSectionB, // lock only if stored & not editing
                    true, // integerOnly
                    "headcount", // field name
                    null, // inputRef
                    "B",
                    (e) => {
                      if (e.key === "Enter") {
                        // ✅ focus Section B submit button
                        // if (sectionBSubmitRef?.current) {
                        //   sectionBSubmitRef.current.focus();
                        // }
                        if (stockInwardRef?.current) {
                          stockInwardRef.current.focus();
                        }
                        e.preventDefault(); // prevent default Enter behavior
                      }
                    }
                  )}
                </div>
              </div>

              <div className="section-actions">
                {/* Submit Button */}
                {/* <button
                  type="button"
                  className="submit-button"
                  ref={sectionBSubmitRef}
                  onClick={() => handleSectionSubmit("B")}
                  disabled={!isSectionBChanged}
                  style={{
                    backgroundColor:
                      !isEditingSectionB && isSectionBChanged
                        ? "green"
                        : "grey",
                    color: "white",
                    padding: "8px 16px",
                    border: "none",
                    borderRadius: "5px",
                    cursor:
                      !isEditingSectionB && isSectionBChanged
                        ? "pointer"
                        : "not-allowed",
                    marginRight: "8px",
                  }}
                >
                  Submit
                </button> */}

                <button
                  type="button"
                  className="clear-button skip-focus"
                  onClick={() => {
                    clearSectionB();
                  }}
                  disabled={
                    (isStoredDataAvailable("B") && !isEditingSectionB) ||
                    !isSectionBChanged
                  }
                  style={{
                    backgroundColor:
                      (!isStoredDataAvailable("B") || isEditingSectionB) &&
                        isSectionBChanged
                        ? "green"
                        : "grey",
                    color: "white",
                    padding: "8px 16px",
                    border: "none",
                    borderRadius: "5px",
                    cursor:
                      (!isStoredDataAvailable("B") || isEditingSectionB) &&
                        isSectionBChanged
                        ? "pointer"
                        : "not-allowed",
                    marginRight: "8px",
                  }}
                >
                  Clear
                </button>

                {/* Edit Button
                <button
                  type="button"
                  className="edit-button"
                  onClick={() => handleSectionEdit("B")}
                  disabled={
                    !rawSectionData.B ||
                    rawSectionData.B.length === 0 ||
                    isEditingSectionB
                  }
                  style={{
                    backgroundColor:
                      !rawSectionData.B ||
                      rawSectionData.B.length === 0 ||
                      isEditingSectionB
                        ? "grey"
                        : "green",
                    color: "white",
                    padding: "8px 16px",
                    border: "none",
                    borderRadius: "5px",
                    cursor:
                      !rawSectionData.B ||
                      rawSectionData.B.length === 0 ||
                      isEditingSectionB
                        ? "not-allowed"
                        : "pointer",
                    marginRight: "8px",
                  }}
                >
                  Edit
                </button> */}

                {/* Remark Button for Section B */}
                <button
                  type="button"
                  className="remark-button"
                  onClick={() => openRemarkModal("B", "Remarks - Sale Summary")} // normal title
                  disabled={!rawSectionData.B || rawSectionData.B.length === 0}
                  style={{
                    backgroundColor:
                      rawSectionData.B && rawSectionData.B.length > 0
                        ? "green"
                        : "grey",
                    color: "white",
                    fontFamily: "Trebuchet MS",
                    padding: "8px 16px",
                    border: "none",
                    borderRadius: "5px",
                    cursor:
                      rawSectionData.B && rawSectionData.B.length > 0
                        ? "pointer"
                        : "not-allowed",
                  }}
                >
                  Remark
                </button>
                <button
                  type="button"
                  className="submit-button"
                  id="submit-button-section-a"
                  // onClick={handleExportMonthTarget}
                  onClick={() => {
                    setIsMonthTarget(true);
                    handleSectionClick("B");
                  }}
                  style={{
                    backgroundColor: "green",
                    color: "white",
                    padding: "8px 16px",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                >
                  Month Target
                </button>
              </div>

              {/* Remark Modal for Section B */}
              {isRemarkModalOpenB && (
                <RemarkModal
                  isOpen={isRemarkModalOpenB}
                  section="B"
                  modalTitle={remarkModalTitleB} // ✅ dynamic title
                  onClose={() => setIsRemarkModalOpenB(false)}
                  userID={userID}
                  selectedDate={selectedDate}
                />
              )}
            </div>

            {/* C. QUANTITATIVE INFORMATION */}
            <div className="section-container section-c" style={{ position: "relative" }}>
              <h3
                style={{
                  marginTop: "1px",
                  marginBottom: "20px",
                  color: "black",
                  cursor: "pointer",
                }}
                onMouseOver={(e) => {
                  e.target.style.color = "#1E90FF"; // Hover color
                  e.target.style.textDecoration = "underline";
                }}
                onMouseOut={(e) => {
                  e.target.style.color = "black"; // Reset color
                  e.target.style.textDecoration = "none";
                }}
                onClick={() => handleSectionClick("C")}
              >
                C. QUANTITATIVE INFORMATION (Pcs)
              </h3>
              <div className="section-c-grid">
                <div className="form-group opening-stock">
                  <label>Opening Stock</label>
                  {renderInput(
                    openingStock,
                    setOpeningStock,
                    selectedDate !== "2026-01-01" || isOpeningStockReadOnly,
                    true // integerOnly
                  )}
                </div>

                {/* STOCK INWARD */}
                <div className="form-group stock-inward-ho">
                  {/* <label>Stock Inward from HO/Other Stores</label> */}
                  <label>
                    {(() => {
                      const selectedISO = new Date(selectedDate)
                        .toISOString()
                        .split("T")[0];
                      const sectionCData = rawSectionData.C || [];
                      const currentSelectedC = sectionCData.find(
                        (r) => r.Date?.split("T")[0] === selectedISO
                      );

                      return currentSelectedC
                        ? parseFloat(currentSelectedC.StockInwHO) > 0
                          ? "Stock Inward from HO"
                          : parseFloat(currentSelectedC.StockInwStore) > 0
                            ? "Stock Inward from Other Stores"
                            : "Stock Inward from HO/Other Stores"
                        : "Stock Inward from HO/Other Stores";
                    })()}
                  </label>

                  {renderInput(
                    stockInward,
                    setStockInward,
                    isSectionASubmitted && isSectionBSubmitted && isSectionCSubmitted, //isStoredDataAvailable("C") && !isEditingSectionC,
                    true,
                    "stockInward",
                    stockInwardRef,
                    "C",
                    (e) => {
                      if (e.key === "Enter")
                        // stockAdjustmentRef?.current?.focus();
                        stockOutwardRef?.current?.focus();
                    },
                    {
                      onBlur: () => {
                        // Give time for renderInput’s internal onBlur to finish setting 0
                        setTimeout(() => {
                          const value = parseFloat(stockInward);
                          if (!isNaN(value) && value > 0) {
                            setStockModalType("inward");
                            setShowStockModal(true);
                          }
                        }, 100); // slight delay ensures 0 is already set
                      },
                    }
                  )}
                </div>

                {/* STOCK OUTWARD */}
                <div className="form-group stock-outward-stores">
                  {/* <label>Stock Outward to HO/Other Stores</label> */}
                  <label>
                    {(() => {
                      const selectedISO = new Date(selectedDate)
                        .toISOString()
                        .split("T")[0];
                      const sectionCData = rawSectionData.C || [];
                      const currentSelectedC = sectionCData.find(
                        (r) => r.Date?.split("T")[0] === selectedISO
                      );

                      return currentSelectedC
                        ? parseFloat(currentSelectedC.StockOutwHO) > 0
                          ? "Stock Outward to HO"
                          : parseFloat(currentSelectedC.StockOutwStore) > 0
                            ? "Stock Outward to Other Stores"
                            : "Stock Outward to HO/Other Stores"
                        : "Stock Outward to HO/Other Stores";
                    })()}
                  </label>
                  {renderInput(
                    stockOutward,
                    setStockOutward,
                    isSectionASubmitted && isSectionBSubmitted && isSectionCSubmitted,// isStoredDataAvailable("C") && !isEditingSectionC,
                    true,
                    "stockOutward",
                    stockOutwardRef,
                    "C",
                    (e) => {
                      // if (e.key === "Enter") submitButtonCRef.current.focus();
                      if (e.key === "Enter") stockAdjustmentRef.current.focus();
                    },
                    {
                      onBlur: () => {
                        if (parseFloat(stockOutward) > 0) {
                          setStockModalType("outward"); // indicate outward modal
                          setShowStockModal(true); // open modal
                        }
                      },
                    }
                  )}
                </div>

                {/* MODAL */}
                {showStockModal && (
                  <div className="modal-backdrop">
                    <div className="modal">
                      <h3>
                        {stockModalType === "inward"
                          ? "Stock Transfer Details (Inward)"
                          : "Stock Transfer Details (Outward)"}
                      </h3>

                      {/* Stock Type Radio */}
                      <div
                        className="stock-inward-options"
                        style={{
                          display: "flex",
                          gap: "100px",
                          marginBottom: "10px",
                        }}
                      >
                        {stockModalType === "inward" ? (
                          <>
                            <label>
                              <input
                                type="radio"
                                name="stockInwardType"
                                value="inwHO"
                                checked={stockInwardType === "inwHO"}
                                onChange={() => setStockInwardType("inwHO")}
                              />
                              Stock Inward from HO
                            </label>
                            <label>
                              <input
                                type="radio"
                                name="stockInwardType"
                                value="inwOtherStore"
                                checked={stockInwardType === "inwOtherStore"}
                                onChange={() =>
                                  setStockInwardType("inwOtherStore")
                                }
                              />
                              Stock Inward from Other Store
                            </label>
                          </>
                        ) : (
                          <>
                            <label>
                              <input
                                type="radio"
                                name="stockInwardType"
                                value="OwHO"
                                checked={stockInwardType === "OwHO"}
                                onChange={() => setStockInwardType("OwHO")}
                              />
                              Stock Outward to HO
                            </label>
                            <label>
                              <input
                                type="radio"
                                name="stockInwardType"
                                value="OwOtherStore"
                                checked={stockInwardType === "owOtherStore"}
                                onChange={() =>
                                  setStockInwardType("owOtherStore")
                                }
                              />
                              Stock Outward to Other Store
                            </label>
                          </>
                        )}
                      </div>

                      <hr />

                      {/* Invoice Fields */}
                      <label>Stock Transfer Invoice No.:</label>
                      <input
                        type="text"
                        value={invoiceNo}
                        onChange={(e) => setInvoiceNo(e.target.value)}
                      />

                      <label>Stock Transfer Invoice Dt:</label>
                      <input
                        type="date"
                        value={invoiceDate}
                        onChange={(e) => setInvoiceDate(e.target.value)}
                      />

                      {/* Discrepancy Options */}
                      <div>
                        <label>
                          <input
                            type="radio"
                            name="discrepancy"
                            value="none"
                            checked={discrepancyOption === "none"}
                            onChange={() => {
                              setDiscrepancyOption("none");
                              setSelectedDiscrepancies([]);
                              setRemark("");
                            }}
                          />
                          No discrepancies found
                        </label>
                        <br />
                        <label>
                          <input
                            type="radio"
                            name="discrepancy"
                            value="found"
                            checked={discrepancyOption === "found"}
                            onChange={() => setDiscrepancyOption("found")}
                          />
                          Discrepancies found
                        </label>
                      </div>

                      {/* ✅ Discrepancy Checkboxes + Remark */}
                      {discrepancyOption === "found" && (
                        <div
                          className="discrepancy-options"
                          style={{
                            marginTop: "10px",
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "8px",
                          }}
                        >
                          <label>
                            <input
                              type="checkbox"
                              value="Quantity mis-match"
                              checked={selectedDiscrepancies.includes(
                                "Quantity mis-match"
                              )}
                              onChange={(e) => {
                                const val = e.target.value;
                                setSelectedDiscrepancies((prev) =>
                                  prev.includes(val)
                                    ? prev.filter((d) => d !== val)
                                    : [...prev, val]
                                );
                              }}
                            />
                            Quantity mismatch
                          </label>

                          <label>
                            <input
                              type="checkbox"
                              value="Quality mis-match"
                              checked={selectedDiscrepancies.includes(
                                "Quality mis-match"
                              )}
                              onChange={(e) => {
                                const val = e.target.value;
                                setSelectedDiscrepancies((prev) =>
                                  prev.includes(val)
                                    ? prev.filter((d) => d !== val)
                                    : [...prev, val]
                                );
                              }}
                            />
                            Quality mismatch
                          </label>

                          <label>
                            <input
                              type="checkbox"
                              value="Damage Pieces"
                              checked={selectedDiscrepancies.includes(
                                "Damage Pieces"
                              )}
                              onChange={(e) => {
                                const val = e.target.value;
                                setSelectedDiscrepancies((prev) =>
                                  prev.includes(val)
                                    ? prev.filter((d) => d !== val)
                                    : [...prev, val]
                                );
                              }}
                            />
                            Damage Pieces
                          </label>

                          <label>
                            <input
                              type="checkbox"
                              value="Bar Code Tag missing"
                              checked={selectedDiscrepancies.includes(
                                "Bar Code Tag missing"
                              )}
                              onChange={(e) => {
                                const val = e.target.value;
                                setSelectedDiscrepancies((prev) =>
                                  prev.includes(val)
                                    ? prev.filter((d) => d !== val)
                                    : [...prev, val]
                                );
                              }}
                            />
                            Bar Code Tag missing
                          </label>

                          <label style={{ gridColumn: "1 / span 2" }}>
                            <input
                              type="checkbox"
                              value="Other reasons"
                              checked={selectedDiscrepancies.includes(
                                "Other reasons"
                              )}
                              onChange={(e) => {
                                const val = e.target.value;
                                setSelectedDiscrepancies((prev) =>
                                  prev.includes(val)
                                    ? prev.filter((d) => d !== val)
                                    : [...prev, val]
                                );
                              }}
                            />
                            Other reasons
                          </label>

                          {/* Remark input spans both columns */}
                          <div
                            style={{
                              gridColumn: "1 / span 2",
                              marginTop: "10px",
                            }}
                          >
                            <label>Discrepancy Remark:</label>
                            <input
                              type="text"
                              value={remark}
                              onChange={(e) => setRemark(e.target.value)}
                              required={discrepancyOption === "found"}
                              style={{ width: "100%" }}
                            />
                          </div>
                        </div>
                      )}

                      {/* Modal Actions */}
                      <div
                        className="modal-actions"
                        style={{ marginTop: "15px" }}
                      >
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            if (!invoiceNo || !invoiceDate) {
                              alert("Invoice No. and Date are required!");
                              return;
                            }
                            if (
                              discrepancyOption === "found" &&
                              (selectedDiscrepancies.length === 0 ||
                                remark.trim() === "")
                            ) {
                              alert(
                                "Please select at least one discrepancy and enter remark."
                              );
                              return;
                            }
                            saveStockTransfer();
                          }}
                        >
                          Save
                        </button>

                        <button
                          type="button"
                          onClick={() => {
                            setInvoiceNo("");
                            setInvoiceDate("");
                            setDiscrepancyOption("");
                            setSelectedDiscrepancies([]);
                            setRemark("");
                            setStockInwardType("HO"); // reset to default
                          }}
                        >
                          Clear
                        </button>

                        <button onClick={() => setShowStockModal(false)}>
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                <div className="form-group sale-qty">
                  <label>Sale Quantity</label>
                  {renderInput(
                    saleQty, // 1. value
                    setSaleQty, // always allow updates
                    isSectionASubmitted && isSectionBSubmitted && isSectionCSubmitted,//isStoredDataAvailable("C") && !isEditingSectionC, // readonly if saved & not editing
                    true, // integerOnly
                    "saleQty", // name (for highlighting)
                    saleQtyRef, // ✅ attach ref here
                    "C",
                    (e) => {
                      // ✅ On Enter press → focus Stock Adjustment instead of Stock Inward HO
                      if (e.key === "Enter" && stockAdjustmentRef?.current) {
                        stockAdjustmentRef.current.focus();
                      }
                    },
                    // {
                    //   onBlur: () => {
                    //     const qty = parseFloat(saleQty);

                    //     if (!saleQty || qty === 0) {
                    //       const cs = parseFloat(cashSalesA) || 0;
                    //       const es = parseFloat(eSales) || 0;

                    //       // Build dynamic text
                    //       let recorded = "";
                    //       if (cs > 0 && es > 0) {
                    //         recorded = "Cash Sales and E-Sales are already recorded.";
                    //       } else if (cs > 0) {
                    //         recorded = "Cash Sales is already recorded.";
                    //       } else if (es > 0) {
                    //         recorded = "E-Sales is already recorded.";
                    //       }

                    //       // If neither recorded, normal validation
                    //       if (!recorded) {
                    //         Swal.fire({
                    //           icon: "error",
                    //           title: "Invalid Entry",
                    //           text: "Either Cash Sales or E-Sales must be greater than 0."
                    //         });
                    //         return;
                    //       }

                    //       // Show confirmation alert
                    //       Swal.fire({
                    //         icon: "warning",
                    //         title: "Confirm Sale Qty as 0",
                    //         text: `${recorded} Do you still want to enter Sale Qty as 0?`,
                    //         showCancelButton: true,
                    //         confirmButtonText: "Yes",
                    //         cancelButtonText: "No",
                    //         focusConfirm: true,
                    //       }).then((result) => {
                    //         if (result.isConfirmed) {
                    //           console.log("User accepted Sale Qty = 0");
                    //         } else {
                    //           console.log("User cancelled");
                    //         }
                    //       });
                    //     }
                    //   }
                    // }
                  )}
                </div>

                {/* <div className="form-group stock-outward-stores">
                  {
                    <label>
                      Stock Outward to HO/Other Stores
                    </label> 
                  }
                  {renderInput(
                    stockOutward,
                    setStockOutward,
                    isStoredDataAvailable("C") && !isEditingSectionC,
                    true,
                    "stockOutward",
                    stockOutwardRef, // ✅ attach ref,
                    "C",
                    (e) => {
                      if (e.key === "Enter") submitButtonCRef.current.focus();
                    }
                  )}
                </div> */}

                {/* STOCK ADJUSTMENT FIELD */}
                <div className="form-group stock-inward-stores">
                  <label>Stock Adjustment</label>
                  {renderInput(
                    stockAdjustment,
                    setStockAdjustment,
                    isSectionASubmitted && isSectionBSubmitted && isSectionCSubmitted,// isStoredDataAvailable("C") && !isEditingSectionC,
                    true,
                    "stockAdjustment",
                    stockAdjustmentRef, // ✅ attach ref
                    // stockInwardStoresRef,
                    "C",
                    (e) => {
                      // if (e.key === "Enter") submitButtonCRef.current.focus();
                      if (e.key === "Enter") previewBtnRef.current.focus();
                      // if (e.key === "Enter" && stockOutwardRef?.current) {
                      //   stockOutwardRef.current.focus();
                      //   const value = parseFloat(stockInwardStores);
                      //   // if (!isNaN(value) && value !== 0) {
                      //   //   openRemarkModal("C", "Reason for Stock Adjustment"); // ✅ reason title
                      //   // }
                      // }
                    }
                    // {
                    // onBlur: () => {
                    //   const value = parseFloat(stockInwardStores);
                    //   if (!isNaN(value) && value !== 0) {
                    //     openRemarkModal("C", "Reason for Stock Adjustment"); // ✅ reason title
                    //   }
                    // },
                    // }
                  )}
                </div>

                <div className="form-group closing-stock">
                  <label>Closing Stock</label>
                  {renderInput(closingStock, setClosingStock, true, true)}
                </div>
              </div>

              <div
                className="section-actions"
                style={{ textAlign: "right", marginTop: "10px" }}
              >
                {/* Submit Button */}
                {/* <button
                  type="button"
                  className="submit-button"
                  id="submit-button-section-c"
                  ref={submitButtonCRef}
                  onClick={() => handleSectionSubmit("C")}
                  disabled={!isSectionCChanged}
                  style={{
                    backgroundColor:
                      !isEditingSectionC && isSectionCChanged
                        ? "green"
                        : "grey",
                    color: "white",
                    padding: "8px 16px",
                    border: "none",
                    borderRadius: "5px",
                    cursor:
                      !isEditingSectionC && isSectionCChanged
                        ? "pointer"
                        : "not-allowed",
                    marginRight: "8px",
                  }}
                >
                  Submit
                </button> */}
                {/* <button
                  type="button"
                  ref={submitButtonAllRef}
                  onClick={handleAllSubmit}
                  style={{
                    background: "green",
                    color: "white",
                    padding: "10px 18px",
                    borderRadius: "6px",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  Final Submit
                </button> */}

                {/* Clear Button */}
                <button
                  type="button"
                  className="clear-button skip-focus"
                  onClick={() => {
                    clearSectionC();
                  }}
                  disabled={
                    (isStoredDataAvailable("C") && !isEditingSectionC) ||
                    !isSectionCChanged
                  } // respect stored lock and typing
                  style={{
                    backgroundColor:
                      (!isStoredDataAvailable("C") || isEditingSectionC) &&
                        isSectionCChanged
                        ? "green"
                        : "grey",
                    color: "white",
                    padding: "8px 16px",
                    border: "none",
                    borderRadius: "5px",
                    cursor:
                      (!isStoredDataAvailable("C") || isEditingSectionC) &&
                        isSectionCChanged
                        ? "pointer"
                        : "not-allowed",
                    marginRight: "8px",
                  }}
                >
                  Clear
                </button>

                {/* Edit Button
                <button
                  type="button"
                  className="edit-button"
                  id="edit-button-section-c"
                  onClick={() => handleSectionEdit("C")}
                  disabled={
                    !rawSectionData.C ||
                    rawSectionData.C.length === 0 ||
                    isEditingSectionC
                  }
                  style={{
                    backgroundColor:
                      !rawSectionData.C ||
                      rawSectionData.C.length === 0 ||
                      isEditingSectionC
                        ? "grey"
                        : "green",
                    color: "white",
                    padding: "8px 16px",
                    border: "none",
                    borderRadius: "5px",
                    cursor:
                      !rawSectionData.C ||
                      rawSectionData.C.length === 0 ||
                      isEditingSectionC
                        ? "not-allowed"
                        : "pointer",
                  }}
                >
                  Edit
                </button> */}

                {/* Remark Button for Section C */}
                <button
                  type="button"
                  className="remark-button"
                  onClick={() =>
                    openRemarkModal("C", "Remarks - Quantitative Information")
                  } // ✅ remark title
                  disabled={!rawSectionData.C || rawSectionData.C.length === 0}
                  style={{
                    backgroundColor:
                      rawSectionData.C && rawSectionData.C.length > 0
                        ? "green"
                        : "grey",
                    color: "white",
                    fontFamily: "Trebuchet MS",
                    padding: "8px 16px",
                    border: "none",
                    borderRadius: "5px",
                    cursor:
                      rawSectionData.C && rawSectionData.C.length > 0
                        ? "pointer"
                        : "not-allowed",
                  }}
                >
                  Remark
                </button>
              </div>

              {/* Remark Modal for Section C */}
              {isRemarkModalOpenC && (
                <RemarkModal
                  isOpen={isRemarkModalOpenC}
                  section="C"
                  modalTitle={remarkModalTitleC} // ✅ dynamic title
                  onClose={() => setIsRemarkModalOpenC(false)}
                  userID={userID}
                  selectedDate={selectedDate}
                />
              )}
              <button
                type="button"
                onClick={() => setShowPreview(true)}
                ref={previewBtnRef}
                style={{
                  background: "#007bff",
                  color: "white",
                  padding: "12px 24px",        // ⬆️ increased size
                  borderRadius: "6px",
                  fontWeight: "bold",
                  fontSize: "20px",
                  cursor: "pointer",
                  position: "absolute",
                  bottom: "-50px",
                  right: "0px",
                }}
              >
                Preview
              </button>
              {showPreview && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    background: "rgba(0,0,0,0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 9999,
                  }}
                >
                  <Draggable nodeRef={previewModalRef}>
                    <div
                      ref={previewModalRef}
                      style={{
                        background: "white",
                        padding: "24px 32px",
                        borderRadius: "10px",
                        minWidth: "420px",
                        position: "relative",
                      }}
                    >
                      {/* ✅ Close Icon */}
                      <span
                        tabIndex={0} // makes it keyboard-focusable
                        onClick={() => setShowPreview(false)}
                        onKeyDown={(e) => {
                          if (e.key === "Escape") setShowPreview(false);
                        }}
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "14px",
                          fontSize: "50px",
                          fontWeight: "bold",
                          color: "#888",
                          cursor: "pointer",
                          transition: "color 0.2s",
                        }}
                        onMouseEnter={(e) => (e.target.style.color = "black")}
                        onMouseLeave={(e) => (e.target.style.color = "#888")}
                      >
                        &times;
                      </span>

                      <h2 style={{ marginBottom: "20px", textAlign: "center" }}>
                        Preview Report  {selectedDate ? ` - ${formatDate(selectedDate)}` : ""}
                      </h2>
                      <div style={{ lineHeight: "1.8" }}>
                        <p>
                          <strong>Cash Sales:</strong>{" "}
                          {isAllSubmitted ? (
                            <span style={valueStyle}>{cashSalesA}</span>
                          ) : (
                            <button
                              type="button"
                              onClick={() => {
                                setShowPreview(false);
                                setTimeout(() => cashSalesRef.current?.focus(), 300);
                              }}
                              style={{
                                background: "none",
                                border: "none",
                                color: "#0000FF",
                                textDecoration: "underline",
                                cursor: "pointer",
                                fontSize: "20px",
                                fontWeight: "bold",
                                padding: 0,
                              }}
                            >
                              {cashSalesA}
                            </button>
                          )}
                        </p>

                        <p>
                          <strong>E Sales:</strong>{" "}
                          {isAllSubmitted ? (
                            <span style={valueStyle}>{eSales}</span>
                          ) : (
                            <button
                              type="button"
                              onClick={() => {
                                setShowPreview(false);
                                setTimeout(() => eSalesRef.current?.focus(), 300);
                              }}
                              style={{
                                background: "none",
                                border: "none",
                                color: "#0000FF",
                                textDecoration: "underline",
                                cursor: "pointer",
                                fontSize: "20px",
                                fontWeight: "bold",
                                padding: 0,
                              }}
                            >
                              {eSales}
                            </button>
                          )}
                        </p>

                        <p>
                          <strong>Cash Deposit:</strong>{" "}
                          {isAllSubmitted ? (
                            <span style={valueStyle}>{cashDeposited}</span>
                          ) : (
                            <button
                              type="button"
                              onClick={() => {
                                setShowPreview(false);
                                setTimeout(() => cashDepositedRef.current?.focus(), 300);
                              }}
                              style={{
                                background: "none",
                                border: "none",
                                color: "#0000FF",
                                textDecoration: "underline",
                                cursor: "pointer",
                                fontSize: "20px",
                                fontWeight: "bold",
                                padding: 0,
                              }}
                            >
                              {cashDeposited}
                            </button>
                          )}
                        </p>

                        <p>
                          <strong>Closing Cash Balance:</strong>{" "}
                          <span style={{
                            background: "none",
                            border: "none",
                            color: "#6a6a6dff",
                            cursor: "pointer",
                            fontSize: "20px",
                            fontWeight: "bold",
                            padding: 0,
                          }}>{closingCash}</span>
                          {/* <button
                          type="button"
                          onClick={() => {
                            setShowPreview(false);
                            // setTimeout(() => closingCashRef.current?.focus(), 300);
                          }}
                          style={{
                            background: "none",
                            border: "none",
                            color: "#0000FF",
                            textDecoration: "underline",
                            cursor: "pointer",
                            fontSize: "20px",
                            fontWeight: "bold",
                            padding: 0,
                          }}
                        >
                          {closingCash}
                        </button> */}

                        </p>

                        <p>
                          <strong>Sales Qty (Pcs):</strong>{" "}
                          {isAllSubmitted ? (
                            <span style={valueStyle}>{saleQty}</span>
                          ) : (
                            <button
                              type="button"
                              onClick={() => {
                                setShowPreview(false);
                                setTimeout(() => saleQtyRef.current?.focus(), 300);
                              }}
                              style={{
                                background: "none",
                                border: "none",
                                color: "#0000FF",
                                textDecoration: "underline",
                                cursor: "pointer",
                                fontSize: "20px",
                                fontWeight: "bold",
                                padding: 0,
                              }}
                            >
                              {saleQty}
                            </button>
                          )}
                        </p>

                        <p>
                          <strong>Stock Inward from HO:</strong>{" "}
                          {isAllSubmitted ? (
                            <span style={valueStyle}>{stockInward}</span>
                          ) : (
                            <button
                              type="button"
                              onClick={() => {
                                setShowPreview(false);
                                setTimeout(() => stockInwardRef.current?.focus(), 300);
                              }}
                              style={{
                                background: "none",
                                border: "none",
                                color: "#0000FF",
                                textDecoration: "underline",
                                cursor: "pointer",
                                fontSize: "20px",
                                fontWeight: "bold",
                                padding: 0,
                              }}
                            >
                              {stockInward || 0}
                            </button>
                          )}
                        </p>

                        <p>
                          <strong>Cash Adjustment:</strong>{" "}
                          {isAllSubmitted ? (
                            <span style={valueStyle}>{cashAdjustment}</span>
                          ) : (
                            <button
                              type="button"
                              onClick={() => {
                                setShowPreview(false);
                                setTimeout(() => cashAdjustmentRef.current?.focus(), 300);
                              }}
                              style={{
                                background: "none",
                                border: "none",
                                color: "#0000FF",
                                textDecoration: "underline",
                                cursor: "pointer",
                                fontSize: "20px",
                                fontWeight: "bold",
                                padding: 0,
                              }}
                            >
                              {cashAdjustment}
                            </button>
                          )}
                        </p>

                        <p>
                          <strong>Sales Adjustment:</strong>{" "}
                          {isAllSubmitted ? (
                            <span style={valueStyle}>{eSalesAdjustment}</span>
                          ) : (
                            <button
                              type="button"
                              onClick={() => {
                                setShowPreview(false);
                                setTimeout(() => eSalesAdjustmentRef.current?.focus(), 300);
                              }}
                              style={{
                                background: "none",
                                border: "none",
                                color: "#0000FF",
                                textDecoration: "underline",
                                cursor: "pointer",
                                fontSize: "20px",
                                fontWeight: "bold",
                                padding: 0,
                              }}
                            >
                              {eSalesAdjustment}
                            </button>
                          )}
                        </p>
                      </div>


                      <div style={{
                        display: "flex", float: "right", marginTop: "22px"
                      }}>
                        {/* EDIT BUTTON */}
                        <button
                          type="button"
                          onClick={() => setShowPreview(false)}
                          disabled={isAllSubmitted}
                          style={{
                            // background: isAllSubmitted ? "#b0b0b0" : "gray",
                            background: isAllSubmitted ? "#8fc98f" : "green",
                            color: "white",
                            padding: "12px 24px",        // ⬆️ increased size
                            fontSize: "20px",
                            fontWeight: "bold",
                            borderRadius: "6px",
                            cursor: isAllSubmitted ? "not-allowed" : "pointer",
                            marginRight: "6px",
                            opacity: isAllSubmitted ? 0.6 : 1,
                          }}
                        >
                          Edit
                        </button>
                        {/* FINAL SUBMIT BUTTON */}
                        <button
                          type="button"
                          ref={submitButtonAllRef}
                          autoFocus
                          disabled={isAllSubmitted}
                          onClick={() => {
                            if (!isAllSubmitted) {
                              setShowPreview(false);
                              handleAllSubmit(); // final submit
                            }
                          }}
                          style={{
                            background: isAllSubmitted ? "#8fc98f" : "green",
                            color: "white",
                            padding: "15px 30px",        // ⬆️ increased size
                            borderRadius: "6px",
                            fontSize: "20px",
                            fontWeight: "bold",
                            cursor: isAllSubmitted ? "not-allowed" : "pointer",
                            opacity: isAllSubmitted ? 0.6 : 1,
                          }}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </Draggable>
                </div>
              )}

            </div>
          </div>
          {/* <Chatbot /> */}

          {/* <div
            className="upload-bar"
            style={{ display: "flex", gap: "10px", alignItems: "center" }}
          >
            <select
              // value={}
              onChange={(e) => setSelectedStore(e.target.value)}
            >
              <option value="">-- Select Store --</option>
              {stores.map((store) => (
                <option key={store.StoreID} value={store.StoreID}>
                  {store.StoreName}
                </option>
              ))}
            </select>

            <input
              type="file"
              onChange={(e) => setFile(e.target.files?.[0] ?? null)}
            />

            <div className="upload-btn-wrapper">
              <button type="button" onClick={handleUpload}>
                Upload
              </button>
            </div>
          </div> */}
          {/* ✅ Show upload section only for admin */}
          {isAdmin === 1 && (
            <div
              className="upload-bar"
              style={{ display: "flex", gap: "10px", alignItems: "center" }}
            >
              {/* File input only */}
              <input
                type="file"
                onChange={(e) => setFile(e.target.files?.[0] ?? null)}
              />

              {/* Button wrapper */}
              <div className="upload-btn-wrapper">
                <button type="button" onClick={handleUpload}>
                  Upload
                </button>
              </div>
              {isUploading && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(0,0,0,0.35)",
                    backdropFilter: "blur(3px)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 9999
                  }}
                >
                  <div
                    style={{
                      background: "white",
                      padding: "20px 40px",
                      borderRadius: "8px",
                      textAlign: "center",
                      boxShadow: "0 0 15px rgba(0,0,0,0.2)"
                    }}
                  >
                    {/* 5-dot loader */}
                    <div className="loader-circle">
                      <div></div><div></div><div></div><div></div><div></div>
                    </div>

                    <h3 style={{ marginTop: "10px" }}>Uploading...</h3>
                  </div>
                </div>
              )}

            </div>
          )}
        </form>
        {submittedRows.length > 0 && (
          <>
            <div
              className="summary-table-wrapper"
              style={{
                overflowX: "auto",
                height: "500px",
                overflowY: "auto",
                display: visibleSection === "A" ? "inline-block" : "block", // 🟡 wrap Section A tightly
                border: "1px solid #ccc",
                margin: "20px auto",
                verticalAlign: "top", // 🟢 ensures inline-block aligns to top
                paddingTop: 0, // 🟢 no padding
              }}
            >
              {/* <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "10px",
                }}
              >
                {visibleSection && (
                  <button
                    style={{
                      padding: "8px 16px",
                      backgroundColor: "#1c5bd1",
                      color: "#fff",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                      right: "70px",
                    }}
                    onClick={() => handleExportSectionExcel(visibleSection)}
                  >
                    Export Excel
                  </button>
                )}
              </div> */}
              <table
                className="summary-table"
                style={{
                  borderCollapse: "collapse",
                  tableLayout: "auto",
                  width: "auto",
                  minWidth: "200px",
                  margin: 0,
                  padding: 0,
                }}
              >
                <thead>
                  <tr>
                    <th
                      rowSpan="2"
                      style={{
                        fontSize: "20px",
                        backgroundColor: "#f0f4c3", // light greenish-yellow
                        textAlign: "center",
                      }}
                    >
                      Date
                    </th>

                    {visibleSection === "A" && (
                      <th
                        colSpan="6"
                        style={{
                          backgroundColor: "rgb(224, 247, 250)",
                          fontSize: "20px",
                          textAlign: "center",
                          position: "sticky", // ✅ keeps header visible when scrolling
                          top: 0,
                          zIndex: 2,
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "rgb(224, 247, 250)",
                            fontSize: "20px",
                            position: "relative", // 🔹 needed for absolute positioning
                            textAlign: "center", // 🔹 keep text centered
                          }}
                        >
                          <span>Sales Cash Balance</span>
                          <button
                            style={{
                              backgroundColor: "#217346", // Classic Excel green
                              color: "white",
                              border: "none",
                              borderRadius: "6px",
                              fontWeight: "bold",
                              fontSize: "14px",
                              cursor: "pointer",
                              position: "absolute",
                              right: "8px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              padding: "6px 14px",
                              transition: "all 0.2s ease-in-out",
                              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                            }}
                            onMouseOver={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              "#1e6b3b")
                            }
                            onMouseOut={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              "#217346")
                            }
                            onClick={() => handleExportSectionExcel("A")}
                          >
                            <Tippy content="Export as Excel" placement="right">
                              <span>Excel</span>
                            </Tippy>
                          </button>
                        </div>
                      </th>
                    )}

                    {visibleSection === "B" && (
                      <th
                        colSpan={isMonthTarget ? "8" : "16"}
                        style={{
                          backgroundColor: "rgb(232, 245, 233)",
                          fontSize: "20px",
                          textAlign: "center", // keep text centered
                          position: "sticky", // ✅ keeps header visible when scrolling
                          top: 0,
                          zIndex: 2,
                        }}
                      >
                        {isMonthTarget ? "Month Wise Target" : "Sales Summary"}
                        <button
                          style={{
                            backgroundColor: "#217346", // Classic Excel green
                            color: "white",
                            border: "none",
                            borderRadius: "6px",
                            fontWeight: "bold",
                            fontSize: "14px",
                            cursor: "pointer",
                            position: "absolute",
                            right: "18px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            padding: "6px 14px",
                            transition: "all 0.2s ease-in-out",
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                          }}
                          onMouseOver={(e) =>
                            (e.currentTarget.style.backgroundColor = "#1e6b3b")
                          }
                          onMouseOut={(e) =>
                            (e.currentTarget.style.backgroundColor = "#217346")
                          }
                          // onClick={() => handleExportSectionExcel("B")}
                          onClick={() =>
                            isMonthTarget
                              ? handleExportMonthTarget()
                              : handleExportSectionExcel("B")
                          }
                        >
                          <Tippy content="Export as Excel" placement="right">
                            <span>Excel</span>
                          </Tippy>
                        </button>
                      </th>
                    )}

                    {/* Section C */}
                    {visibleSection === "C" && (
                      <>
                        {/* Top grouped headers */}
                        <th
                          colSpan="9"
                          style={{
                            backgroundColor: "rgb(255, 248, 225)",
                            fontSize: "20px",
                            textAlign: "center",
                            position: "sticky",
                            top: 0,
                            zIndex: 2,
                          }}
                        >
                          Quantity Details
                          <button
                            style={{
                              backgroundColor: "#217346", // Classic Excel green
                              color: "white",
                              border: "none",
                              borderRadius: "6px",
                              fontWeight: "bold",
                              fontSize: "14px",
                              cursor: "pointer",
                              position: "absolute",
                              right: "8px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              padding: "6px 14px",
                              transition: "all 0.2s ease-in-out",
                              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                            }}
                            onMouseOver={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              "#1e6b3b")
                            }
                            onMouseOut={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              "#217346")
                            }
                            onClick={() => handleExportSectionExcel("C")}
                          >
                            <Tippy content="Export as Excel" placement="right">
                              <span>Excel</span>
                            </Tippy>
                          </button>
                        </th>

                        <th
                          colSpan="2"
                          style={{
                            backgroundColor: "rgb(255, 248, 225)", // greenish
                            fontSize: "20px",
                            textAlign: "center",
                            position: "sticky",
                            top: 0,
                            zIndex: 2,
                          }}
                        >
                          Stock Transfer Details
                        </th>
                      </>
                    )}
                  </tr>

                  <tr>
                    {/* Section A */}
                    {visibleSection === "A" && (
                      <>
                        <th
                          style={{
                            backgroundColor: "#e0f7fa",
                            textAlign: "right",
                          }}
                        >
                          OB
                        </th>
                        <th
                          style={{
                            backgroundColor: "#e0f7fa",
                            textAlign: "right",
                          }}
                        >
                          Sales
                        </th>
                        <th
                          style={{
                            backgroundColor: "#e0f7fa",
                            textAlign: "right",
                          }}
                        >
                          Dep.
                        </th>
                        <th
                          style={{
                            backgroundColor: "#e0f7fa",
                            textAlign: "right",
                          }}
                        >
                          CB
                        </th>
                        <th
                          style={{
                            backgroundColor: "#e0f7fa",
                            textAlign: "right",
                          }}
                        >
                          Cash Adj.
                        </th>
                        <th
                          style={{
                            backgroundColor: "#e0f7fa",
                            textAlign: "right",
                          }}
                        >
                          Remarks
                        </th>
                      </>
                    )}

                    {/* Section B */}
                    {visibleSection === "B" && (
                      <>
                        {isMonthTarget ? (
                          <>
                            <th style={{ backgroundColor: "#e8f5e9" }}>Day</th>
                            <th style={{ backgroundColor: "#e8f5e9" }}>
                              Daily %
                            </th>
                            <th style={{ backgroundColor: "#e8f5e9" }}>
                              Daily Target
                            </th>
                            <th style={{ backgroundColor: "#e8f5e9" }}>
                              T.Pcs
                            </th>
                            <th style={{ backgroundColor: "#e8f5e9" }}>
                              MTD Amt
                            </th>
                            <th style={{ backgroundColor: "#e8f5e9" }}>
                              MTD Pcs
                            </th>
                            <th style={{ backgroundColor: "#e8f5e9" }}>
                              Mth.Tgt Amt
                            </th>
                            <th style={{ backgroundColor: "#e8f5e9" }}>
                              Mth.Tgt Pcs
                            </th>
                          </>
                        ) : (
                          <>
                            <th style={{ backgroundColor: "#e8f5e9" }}>
                              Cash Sales
                            </th>
                            <th style={{ backgroundColor: "#e8f5e9" }}>
                              E-Sales
                            </th>
                            <th style={{ backgroundColor: "#e8f5e9" }}>
                              E-Sales Adj.
                            </th>
                            <th style={{ backgroundColor: "#e8f5e9" }}>
                              GV Red.
                            </th>
                            <th style={{ backgroundColor: "#e8f5e9" }}>
                              Day Target
                            </th>
                            <th style={{ backgroundColor: "#e8f5e9" }}>
                              Total Sales
                            </th>
                            <th style={{ backgroundColor: "#e8f5e9" }}>
                              MTD Target
                            </th>
                            <th style={{ backgroundColor: "#e8f5e9" }}>
                              MTD Sale
                            </th>
                            <th style={{ backgroundColor: "#e8f5e9" }}>
                              Backlog
                            </th>
                            <th style={{ backgroundColor: "#e8f5e9" }}>
                              Mth.Target
                            </th>
                            <th style={{ backgroundColor: "#e8f5e9" }}>
                              Achieved %
                            </th>
                            <th style={{ backgroundColor: "#e8f5e9" }}>
                              Total Bills
                            </th>
                            <th style={{ backgroundColor: "#e8f5e9" }}>
                              Manual Bill No
                            </th>
                            <th style={{ backgroundColor: "#e8f5e9" }}>
                              Walk Ins
                            </th>
                            <th style={{ backgroundColor: "#e8f5e9" }}>
                              Head Count
                            </th>
                            <th style={{ backgroundColor: "#e8f5e9" }}>
                              Remarks
                            </th>
                          </>
                        )}
                      </>
                    )}

                    {/* Section C */}
                    {visibleSection === "C" && (
                      <>
                        {/* Quantity Details columns */}
                        <th style={{ backgroundColor: "#fff8e1" }}>OB</th>
                        <th style={{ backgroundColor: "#fff8e1" }}>
                          IW from HO
                        </th>
                        <th style={{ backgroundColor: "#fff8e1" }}>
                          IW from OS
                        </th>
                        <th style={{ backgroundColor: "#fff8e1" }}>OW to HO</th>
                        <th style={{ backgroundColor: "#fff8e1" }}>OW to OS</th>
                        <th style={{ backgroundColor: "#fff8e1" }}>Sale</th>
                        <th style={{ backgroundColor: "#fff8e1" }}>
                          Stock Adj.
                        </th>
                        <th style={{ backgroundColor: "#fff8e1" }}>CB</th>
                        <th style={{ backgroundColor: "#fff8e1" }}>Remarks</th>

                        {/* Stock Transfer Details columns */}
                        <th style={{ backgroundColor: "#fff8e1" }}>
                          Invoice No.
                        </th>
                        <th style={{ backgroundColor: "#fff8e1" }}>
                          Invoice Date
                        </th>
                      </>
                    )}
                  </tr>
                </thead>

                <tbody>
                  {submittedRows
                    .slice()
                    .sort((a, b) => new Date(b.date) - new Date(a.date))
                    .map((row, i) => (
                      <tr
                        key={i}
                        onClick={() => handleRowClick(row)}
                        style={{
                          backgroundColor:
                            selectedRow === row ? "#d5f1f3ff" : "transparent",
                          cursor: "pointer",
                        }}
                      >
                        <td>
                          {(() => {
                            const dateObj = new Date(row.date);
                            const day = String(dateObj.getDate()).padStart(
                              2,
                              "0"
                            );
                            const month = String(
                              dateObj.getMonth() + 1
                            ).padStart(2, "0");
                            const year = dateObj.getFullYear();
                            return `${day}-${month}-${year}`;
                          })()}
                        </td>

                        {/* Section A */}
                        {visibleSection === "A" && (
                          <>
                            <td style={{ textAlign: "right" }}>
                              {row.data["Opening Store Cash Balance (₹)"] ||
                                "-"}
                            </td>
                            <td style={{ textAlign: "right" }}>
                              {row.data["Cash Sales for the Day (₹)"] !==
                                undefined &&
                                row.data["Cash Sales for the Day (₹)"] !== null &&
                                row.data["Cash Sales for the Day (₹)"] !== ""
                                ? parseFloat(
                                  row.data["Cash Sales for the Day (₹)"]
                                ).toFixed(2)
                                : "-"}
                            </td>
                            <td style={{ textAlign: "right" }}>
                              {parseFloat(
                                row.data["Cash Deposited Today (₹)"]
                              ) === 0
                                ? "-"
                                : row.data["Cash Deposited Today (₹)"]}
                            </td>
                            <td style={{ textAlign: "right" }}>
                              {row.data["Closing Cash Balance (₹)"] || "-"}
                            </td>
                            <td style={{ textAlign: "right" }}>
                              {row.data["Cash Adjustment (₹)"] || "-"}
                            </td>
                            <td>
                              {row.data["Remarks of A"] ? (
                                <Tippy
                                  content={row.data["Remarks of A"]}
                                  placement="right"
                                >
                                  <span
                                    style={{
                                      cursor: "pointer",
                                      color: "blue",
                                      // textDecoration: "underline",
                                    }}
                                  >
                                    Yes
                                  </span>
                                </Tippy>
                              ) : (
                                "-"
                              )}
                            </td>
                          </>
                        )}

                        {/* Section B */}
                        {visibleSection === "B" && (
                          <>
                            {isMonthTarget ? (
                              <>
                                <td style={{ textAlign: "center" }}>
                                  {row.data["Day"] || "-"}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {row.data["Day Target %"] || "-"}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {row.data["Day Value (₹)"] || "-"}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {row.data["T.Pcs"] || "-"}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {row.data["MTD Value (₹)"] || "-"}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {row.data["MTD T.Pcs"] || "-"}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {row.data["Month T.Value (₹)"] || "-"}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {row.data["Month T.Pcs"] || "-"}
                                </td>
                              </>
                            ) : (
                              <>
                                <td style={{ textAlign: "right" }}>
                                  {row.data["Cash Sales (₹)"] || "-"}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {row.data["E-Sales (₹)"] || "-"}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {row.data["E-Sales Adjustment (₹)"] || "-"}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {row.data["GV Redemption (₹)"] || "-"}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {row.data["Day Target (₹)"] || "-"}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {row.data["Total Sales (₹)"] || "-"}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {row.data["MTD Target (₹)"] || "-"}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {row.data["MTD Sales (₹)"] || "-"}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {row.data["Backlog (₹)"] || "-"}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {row.data["Month Target (₹)"] || "-"}
                                </td>
                                <td>{row.data["Achieved %"] || "-"}</td>
                                <td>{row.data["Total Bills"] || "-"}</td>
                                <td>{row.data["Manual Bill No"] || "-"}</td>
                                <td>{row.data["Walkins"] || "-"}</td>
                                <td>{row.data["Headcount"] || "-"}</td>

                                <td>
                                  {row.data["Remarks of B"] ? (
                                    <Tippy
                                      content={row.data["Remarks of B"]}
                                      placement="right"
                                    >
                                      <span
                                        style={{
                                          cursor: "pointer",
                                          color: "blue",
                                        }}
                                      >
                                        Yes
                                      </span>
                                    </Tippy>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                              </>
                            )}
                          </>
                        )}

                        {/* Section C */}
                        {visibleSection === "C" && (
                          <>
                            <td>{row.data["Opening Stock"] || "-"}</td>
                            <td>{row.data["Stock Inward from HO"] || "-"}</td>
                            <td>
                              {row.data["Stock Inward from Other Stores"] ||
                                "-"}
                            </td>
                            <td>{row.data["Stock Outward to HO"] || "-"}</td>
                            <td>
                              {row.data["Stock Outward to Other Stores"] || "-"}
                            </td>
                            <td>{row.data["Sale Quantity"] || "-"}</td>
                            <td>{row.data["Stock Adjustment"] || "-"}</td>
                            <td>{row.data["Closing Stock"] || "-"}</td>
                            <td>
                              {row.data["Remarks of C"] &&
                                row.data["Remarks of C"].trim() !== "" &&
                                row.data["Remarks of C"].trim() !== "-" ? (
                                <Tippy
                                  content={row.data["Remarks of C"]}
                                  placement="right"
                                >
                                  <span
                                    style={{ cursor: "pointer", color: "blue" }}
                                  >
                                    Yes
                                  </span>
                                </Tippy>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td>
                              {row.data["Stock Transfer Invoice No."] || "-"}
                            </td>
                            <td>
                              {row.data["Stock Transfer Invoice Date"] || "-"}
                            </td>
                          </>
                        )}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Dashboard;
